import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date time scalar */
  DateTime: any;
};

export type AccountTranferLogs = {
  __typename?: 'AccountTranferLogs';
  fromEmployee: Employee;
  fromEmployeeID: Scalars['Int'];
  id: Scalars['Int'];
  toEmployee: Employee;
  toEmployeeID: Scalars['Int'];
  transferDate: Scalars['DateTime'];
};

export type AccountTranferQueryForInput = {
  fromEmployeeID?: InputMaybe<Scalars['Int']>;
  toEmployeeID?: InputMaybe<Scalars['Int']>;
};

export type AccountTransferInput = {
  fromEmployeeID: Scalars['Int'];
  toEmployeeID: Scalars['Int'];
};

export type ArticleLinks = {
  __typename?: 'ArticleLinks';
  articleLink?: Maybe<Scalars['String']>;
  articleWordCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  keywords?: Maybe<Scalars['String']>;
  niche?: Maybe<Scalars['String']>;
  publishingDate?: Maybe<Scalars['DateTime']>;
  submissionDate?: Maybe<Scalars['DateTime']>;
};

export type Client = {
  __typename?: 'Client';
  clientBaseURL?: Maybe<Array<Maybe<ClientBaseUrl>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientBaseUrl = {
  __typename?: 'ClientBaseURL';
  baseURL: Scalars['String'];
  clientID: Scalars['Int'];
  id: Scalars['Int'];
};

export type ClientSelectedSite = {
  __typename?: 'ClientSelectedSite';
  id?: Maybe<Scalars['Int']>;
  orderID?: Maybe<Scalars['String']>;
  siteURL?: Maybe<Scalars['String']>;
};

export type ClientSiteUrl = {
  __typename?: 'ClientSiteURL';
  clientSiteURL?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
  requiredDA?: Maybe<Scalars['Int']>;
  requiredDR?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  contactType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentOrder = {
  __typename?: 'ContentOrder';
  PbnName?: Maybe<Scalars['String']>;
  articleLink?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clientID?: Maybe<Scalars['Int']>;
  clientSiteURL?: Maybe<Scalars['String']>;
  cmsAdmin?: Maybe<Employee>;
  cmsAdminID?: Maybe<Scalars['Int']>;
  cmsEmployee?: Maybe<Employee>;
  cmsEmployeeID?: Maybe<Scalars['Int']>;
  contentOrderServiceTypeAttributeValue?: Maybe<Array<Maybe<ContentOrderServiceTypeAttributeValue>>>;
  id?: Maybe<Scalars['String']>;
  orderDescription?: Maybe<Scalars['String']>;
  orderDueDate?: Maybe<Scalars['DateTime']>;
  orderStartDate?: Maybe<Scalars['DateTime']>;
  orderStatus?: Maybe<Scalars['String']>;
  serviceType?: Maybe<ContentOrderServiceType>;
  serviceTypeID?: Maybe<Scalars['Int']>;
  wordCount?: Maybe<Scalars['Int']>;
};

export type ContentOrderServiceType = {
  __typename?: 'ContentOrderServiceType';
  ContentOrderServiceTypeAttribute?: Maybe<Array<Maybe<ContentOrderServiceTypeAttribute>>>;
  disabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  serviceType?: Maybe<Scalars['String']>;
};

export type ContentOrderServiceTypeAttribute = {
  __typename?: 'ContentOrderServiceTypeAttribute';
  attributeName?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  serviceType?: Maybe<ContentOrderServiceType>;
  serviceTypeID?: Maybe<Scalars['Int']>;
};

export type ContentOrderServiceTypeAttributeValue = {
  __typename?: 'ContentOrderServiceTypeAttributeValue';
  contentOrder?: Maybe<ContentOrder>;
  contentOrderID?: Maybe<Scalars['String']>;
  serviceTypeAttribute?: Maybe<ContentOrderServiceTypeAttribute>;
  serviceTypeAttributeID?: Maybe<Scalars['Int']>;
  serviceTypeAttributeValue?: Maybe<Scalars['String']>;
};

export type ContentOrderServiceTypeAttributeValueInput = {
  contentOrderID?: InputMaybe<Scalars['String']>;
  serviceTypeAttributeID?: InputMaybe<Scalars['Int']>;
  serviceTypeAttributeValue?: InputMaybe<Scalars['String']>;
};

export type DomainDetails = {
  __typename?: 'DomainDetails';
  POC: Scalars['String'];
  contactType: ContactType;
  contactedBy: Employee;
  dateOfContact: Scalars['DateTime'];
  finalPrice: Scalars['Int'];
  linkInsertionPrice?: Maybe<Scalars['Int']>;
  priceAsked: Scalars['Int'];
  serviceType: ServiceTypes;
  specialPrice: Scalars['Int'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DomainDetailsInput = {
  POC: Scalars['String'];
  contactTypeID: Scalars['Int'];
  contactedByID: Scalars['Int'];
  dateOfContact: Scalars['DateTime'];
  finalPrice: Scalars['Int'];
  linkInsertionPrice?: InputMaybe<Scalars['Int']>;
  priceAsked: Scalars['Int'];
  serviceTypeID: Scalars['Int'];
  specialPrice: Scalars['Int'];
  status: Scalars['String'];
};

export type DomainMasterSheetComments = {
  __typename?: 'DomainMasterSheetComments';
  Domain?: Maybe<MasterSheet>;
  Employee?: Maybe<Employee>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DomainNiche = {
  __typename?: 'DomainNiche';
  domainID?: Maybe<Scalars['Int']>;
  niche?: Maybe<Niche>;
  nicheID?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DomainTransferLogs = {
  __typename?: 'DomainTransferLogs';
  fromEmployee?: Maybe<Employee>;
  fromEmployeeID?: Maybe<Scalars['Int']>;
  fromFinalPrice?: Maybe<Scalars['Int']>;
  fromPOC?: Maybe<Scalars['String']>;
  fromPriceAsked?: Maybe<Scalars['Int']>;
  fromSiteDA?: Maybe<Scalars['Int']>;
  fromSiteDR?: Maybe<Scalars['Int']>;
  fromSiteTraffic?: Maybe<Scalars['Int']>;
  fromSpecialPrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  request?: Maybe<DomainTransferRequest>;
};

export type DomainTransferRequest = {
  __typename?: 'DomainTransferRequest';
  POC?: Maybe<Scalars['String']>;
  ahrefTraffic?: Maybe<Scalars['Int']>;
  contactType?: Maybe<ContactType>;
  contactTypeID?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<MasterSheet>;
  domainID?: Maybe<Scalars['Int']>;
  employeeRequestBy?: Maybe<Employee>;
  employeeRequestByID?: Maybe<Scalars['Int']>;
  finalPrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  linkInsertionPrice?: Maybe<Scalars['Int']>;
  priceAsked?: Maybe<Scalars['Int']>;
  siteDA?: Maybe<Scalars['Int']>;
  siteDR?: Maybe<Scalars['Int']>;
  siteTraffic?: Maybe<Scalars['Int']>;
  specialPrice?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type DomainTransferRequestStatusInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Employee = {
  __typename?: 'Employee';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MasterSheet = {
  __typename?: 'MasterSheet';
  DomainMasterSheetComments?: Maybe<Array<Maybe<DomainMasterSheetComments>>>;
  DomainNiches: Array<Maybe<DomainNiche>>;
  ahrefTraffic: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  domainDetails: Array<Maybe<DomainDetails>>;
  id: Scalars['Int'];
  siteContactDetails: Array<Maybe<SiteContactDetails>>;
  siteDA: Scalars['Int'];
  siteDR: Scalars['Int'];
  siteTraffic: Scalars['Int'];
  siteUrl: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  acceptDomainTransferRequest?: Maybe<MutationResponse>;
  accountTransfer?: Maybe<MutationResponse>;
  addContentOrderServiceTypeAttribute?: Maybe<MutationResponse>;
  addEmployee?: Maybe<MutationResponse>;
  addNewComment?: Maybe<MutationResponse>;
  addNewPackage?: Maybe<MutationResponse>;
  addNotification?: Maybe<MutationResponse>;
  addSubPackage?: Maybe<MutationResponse>;
  addTodo?: Maybe<MutationResponse>;
  assignCMSAdmin?: Maybe<MutationResponse>;
  assignCMSEmployee?: Maybe<MutationResponse>;
  contentOrderArticleLink?: Maybe<MutationResponse>;
  createContentOrder?: Maybe<MutationResponse>;
  createContentOrderServiceType?: Maybe<MutationResponse>;
  createDomainTransferRequest?: Maybe<MutationResponse>;
  createMasterSheet?: Maybe<MutationResponse>;
  createNiche?: Maybe<MutationResponse>;
  createOrder?: Maybe<MutationResponse>;
  disableEmployee?: Maybe<MutationResponse>;
  disablePackage?: Maybe<MutationResponse>;
  enableEmployee?: Maybe<MutationResponse>;
  forgotPassword?: Maybe<MutationResponse>;
  loginEmployee?: Maybe<MutationResponse>;
  markTodoComplteIncompleteFn?: Maybe<MutationResponse>;
  rejectDomainTransferRequest?: Maybe<MutationResponse>;
  setPassword?: Maybe<MutationResponse>;
  updateCmsOrders?: Maybe<MutationResponse>;
  updateComment?: Maybe<MutationResponse>;
  updateContentOrder?: Maybe<MutationResponse>;
  updateContentOrderServiceType?: Maybe<MutationResponse>;
  updateContentOrderServiceTypeAttribute?: Maybe<MutationResponse>;
  updateContentOrderServiceTypeAttributeStatus?: Maybe<MutationResponse>;
  updateContentOrderServiceTypeStatus?: Maybe<MutationResponse>;
  updateContentOrderStatus?: Maybe<MutationResponse>;
  updateDomain?: Maybe<MutationResponse>;
  updateDomainDetailStatus?: Maybe<MutationResponse>;
  updateDomainTransferRequest?: Maybe<MutationResponse>;
  updateEmployee?: Maybe<MutationResponse>;
  updateMainOrderStatus?: Maybe<MutationResponse>;
  updateMainOrders?: Maybe<MutationResponse>;
  updateNiche?: Maybe<MutationResponse>;
  updateNicheStatus?: Maybe<MutationResponse>;
  updateNotification?: Maybe<MutationResponse>;
  updatePackage?: Maybe<MutationResponse>;
  updatePassword?: Maybe<MutationResponse>;
  updateSeoOrderManager?: Maybe<MutationResponse>;
  updateSeoOrders?: Maybe<MutationResponse>;
  updateSubPackage?: Maybe<MutationResponse>;
  updateTodo?: Maybe<MutationResponse>;
  viewOrderUpdate?: Maybe<MutationResponse>;
  viewOrderUpdateCms?: Maybe<MutationResponse>;
};


export type MutationAcceptDomainTransferRequestArgs = {
  input?: InputMaybe<DomainTransferRequestStatusInput>;
};


export type MutationAccountTransferArgs = {
  input?: InputMaybe<AccountTransferInput>;
};


export type MutationAddContentOrderServiceTypeAttributeArgs = {
  input?: InputMaybe<AddContentOrderServiceTypeAttributeInput>;
};


export type MutationAddEmployeeArgs = {
  input?: InputMaybe<AddEmployee>;
};


export type MutationAddNewCommentArgs = {
  input: NewCommentInput;
};


export type MutationAddNewPackageArgs = {
  input: NewPackage;
};


export type MutationAddNotificationArgs = {
  input?: InputMaybe<NotificationInput>;
};


export type MutationAddSubPackageArgs = {
  input: SubPackageInput;
};


export type MutationAddTodoArgs = {
  input?: InputMaybe<ToDoInput>;
};


export type MutationAssignCmsAdminArgs = {
  input?: InputMaybe<ContentOrderAssignEmployeeIdInput>;
};


export type MutationAssignCmsEmployeeArgs = {
  input?: InputMaybe<ContentOrderAssignEmployeeIdInput>;
};


export type MutationContentOrderArticleLinkArgs = {
  input?: InputMaybe<ContentOrderArticleLinkInput>;
};


export type MutationCreateContentOrderArgs = {
  input?: InputMaybe<CreateContentOrderInput>;
};


export type MutationCreateContentOrderServiceTypeArgs = {
  input?: InputMaybe<CreateContentOrderServiceTypeInput>;
};


export type MutationCreateDomainTransferRequestArgs = {
  input?: InputMaybe<CreateDomainTransferRequestInput>;
};


export type MutationCreateMasterSheetArgs = {
  input?: InputMaybe<CreateMasterSheetInput>;
};


export type MutationCreateNicheArgs = {
  input?: InputMaybe<CreateNicheInput>;
};


export type MutationCreateOrderArgs = {
  input: OrderInput;
};


export type MutationDisableEmployeeArgs = {
  input?: InputMaybe<DisableEmployeeInput>;
};


export type MutationDisablePackageArgs = {
  input: DisablePackageInput;
};


export type MutationEnableEmployeeArgs = {
  input?: InputMaybe<EnableEmployeeInput>;
};


export type MutationForgotPasswordArgs = {
  input?: InputMaybe<ForgotPasswordInput>;
};


export type MutationLoginEmployeeArgs = {
  input?: InputMaybe<LoginEmployeeInput>;
};


export type MutationMarkTodoComplteIncompleteFnArgs = {
  input?: InputMaybe<MarkTodoComplteIncompleteInput>;
};


export type MutationRejectDomainTransferRequestArgs = {
  input?: InputMaybe<DomainTransferRequestStatusInput>;
};


export type MutationSetPasswordArgs = {
  input?: InputMaybe<SetPassword>;
};


export type MutationUpdateCmsOrdersArgs = {
  input: UpdateCmsOrder;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateContentOrderArgs = {
  input?: InputMaybe<UpdateContentOrderInput>;
};


export type MutationUpdateContentOrderServiceTypeArgs = {
  input?: InputMaybe<UpdateContentOrderServiceTypeInput>;
};


export type MutationUpdateContentOrderServiceTypeAttributeArgs = {
  input?: InputMaybe<UpdateContentOrderServiceTypeAttributeInput>;
};


export type MutationUpdateContentOrderServiceTypeAttributeStatusArgs = {
  input?: InputMaybe<UpdateContentOrderServiceTypeAttributeStatusInput>;
};


export type MutationUpdateContentOrderServiceTypeStatusArgs = {
  input?: InputMaybe<UpdateContentOrderServiceTypeStatusInput>;
};


export type MutationUpdateContentOrderStatusArgs = {
  input?: InputMaybe<UpdateContentOrderStatusInput>;
};


export type MutationUpdateDomainArgs = {
  input?: InputMaybe<UpdateDomainInput>;
};


export type MutationUpdateDomainDetailStatusArgs = {
  input?: InputMaybe<UpdateDomainDetailStatusInput>;
};


export type MutationUpdateDomainTransferRequestArgs = {
  input?: InputMaybe<UpdateDomainTransferRequestInput>;
};


export type MutationUpdateEmployeeArgs = {
  input?: InputMaybe<UpdateEmployee>;
};


export type MutationUpdateMainOrderStatusArgs = {
  input?: InputMaybe<UpdateMainOrderStatusInput>;
};


export type MutationUpdateMainOrdersArgs = {
  input: UpdateMainOrder;
};


export type MutationUpdateNicheArgs = {
  input?: InputMaybe<UpdateNicheInput>;
};


export type MutationUpdateNicheStatusArgs = {
  input?: InputMaybe<UpdateNicheStatusInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: InputMaybe<UpdateNotificationInput>;
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackage;
};


export type MutationUpdatePasswordArgs = {
  input?: InputMaybe<UpdatePassword>;
};


export type MutationUpdateSeoOrderManagerArgs = {
  input?: InputMaybe<UpdateSeoOrderManagerInput>;
};


export type MutationUpdateSeoOrdersArgs = {
  input: UpdateSeoOrder;
};


export type MutationUpdateSubPackageArgs = {
  input: UpdateSubPackage;
};


export type MutationUpdateTodoArgs = {
  input?: InputMaybe<UpdateTodoInput>;
};


export type MutationViewOrderUpdateArgs = {
  input?: InputMaybe<ViewOrderUpdateInput>;
};


export type MutationViewOrderUpdateCmsArgs = {
  input?: InputMaybe<ViewOrderUpdateInputCms>;
};

export type NewPackage = {
  description?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type Niche = {
  __typename?: 'Niche';
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  niche?: Maybe<Scalars['String']>;
  nicheAbbr?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Notification = {
  __typename?: 'Notification';
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fromEmployeeID?: Maybe<Scalars['Int']>;
  fromEmployeeNotification?: Maybe<Employee>;
  id?: Maybe<Scalars['Int']>;
  redirectUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  toEmployeeID?: Maybe<Scalars['Int']>;
  toEmployeeNotification?: Maybe<Employee>;
};

export type OrderInput = {
  clientBaseURL?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientName: Scalars['String'];
  clientSiteURL?: InputMaybe<Array<InputMaybe<ClientSiteUrlInput>>>;
  cmsOrder: CmsOrderInput;
  mainOrder: MainOrderInput;
  selectedSite?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoOrder: SeoOrderInput;
};

export type Query = {
  __typename?: 'Query';
  AccountTranferLogsFor?: Maybe<Array<Maybe<AccountTranferLogs>>>;
  _empty?: Maybe<Scalars['String']>;
  accessToken: Scalars['String'];
  accountTransferLogs?: Maybe<Array<Maybe<AccountTranferLogs>>>;
  allNiches?: Maybe<Array<Maybe<Niche>>>;
  cmsOrders?: Maybe<Array<CmsOrders>>;
  domain?: Maybe<MasterSheet>;
  generateContentOrderID?: Maybe<Scalars['String']>;
  getAllContactType?: Maybe<Array<Maybe<ContactType>>>;
  getAllContentOrderServiceTypes?: Maybe<Array<Maybe<ContentOrderServiceType>>>;
  getAllNiches?: Maybe<Array<Maybe<Scalars['String']>>>;
  getAllNichesForDomain?: Maybe<Array<Maybe<Scalars['String']>>>;
  getAllOrderTypes?: Maybe<Array<Maybe<OrderType>>>;
  getAllPackages?: Maybe<Array<Maybe<Package>>>;
  getAllServiceType?: Maybe<Array<Maybe<ServiceTypes>>>;
  getAllSiteContactDetailsForDomain?: Maybe<Array<Maybe<Scalars['String']>>>;
  getCmsOrderByID?: Maybe<CmsOrders>;
  getComment?: Maybe<Array<Maybe<Comments>>>;
  getCommentByOrderID?: Maybe<Array<Maybe<Comments>>>;
  getContentOrder?: Maybe<ContentOrder>;
  getContentOrderServiceType?: Maybe<ContentOrderServiceType>;
  getContentOrderServiceTypeAttribute?: Maybe<Array<Maybe<ContentOrderServiceTypeAttribute>>>;
  getContentOrderServiceTypeAttributeValue?: Maybe<Array<Maybe<ContentOrderServiceTypeAttributeValue>>>;
  getContentOrderServiceTypeAttributes?: Maybe<Array<Maybe<ContentOrderServiceTypeAttribute>>>;
  getContentOrderServiceTypes?: Maybe<Array<Maybe<ContentOrderServiceType>>>;
  getContentOrders?: Maybe<Array<Maybe<ContentOrder>>>;
  getCounts?: Maybe<GetCounts>;
  getEmployeeByEmail?: Maybe<Employee>;
  getEmployeeId?: Maybe<Employee>;
  getEmployeeUsingToken?: Maybe<Employee>;
  getEmployeeWithRole?: Maybe<Array<Maybe<Employee>>>;
  getEmployees?: Maybe<Array<Maybe<Employee>>>;
  getNiches?: Maybe<Array<Maybe<Niche>>>;
  getNotificationById?: Maybe<Array<Maybe<Notification>>>;
  getNotifications?: Maybe<Array<Maybe<Notification>>>;
  getOrderByID?: Maybe<MainOrders>;
  getOrderGeneratedID?: Maybe<Scalars['String']>;
  getPackage?: Maybe<Package>;
  getPaginatedPotentialSitesForClient?: Maybe<PaginatedDmsOutput>;
  getSeoOrderByID?: Maybe<SeoOrders>;
  getSubPackage?: Maybe<SubPackage>;
  getTodos?: Maybe<Array<Maybe<Todo>>>;
  getTodosById?: Maybe<Array<Maybe<Todo>>>;
  getTransferDomainLogs?: Maybe<Array<Maybe<DomainTransferLogs>>>;
  getTransferRequest?: Maybe<DomainTransferRequest>;
  getTransferRequests?: Maybe<Array<Maybe<DomainTransferRequest>>>;
  isLoggedIn: Scalars['Boolean'];
  masterSheet?: Maybe<MasterSheet>;
  masterSheets?: Maybe<Array<Maybe<MasterSheet>>>;
  orders?: Maybe<Array<Maybe<MainOrders>>>;
  paginatedClientSelectedSiteList?: Maybe<PaginatedClientSelectedSiteListOutput>;
  paginatedCmsAdminOrderList?: Maybe<PaginatedOrderListOutput>;
  paginatedCmsOrderList?: Maybe<PaginatedCmsOrderListOutput>;
  paginatedContentOrderList?: Maybe<PaginatedContentOrderListOutput>;
  paginatedEmployeeList?: Maybe<PaginatedEmpOutput>;
  paginatedMasterSheet?: Maybe<PaginatedDmsOutput>;
  paginatedOrderList?: Maybe<PaginatedOrderListOutput>;
  paginatedPackageList?: Maybe<PaginatedPackageOutput>;
  paginatedSeoOrderList?: Maybe<PaginatedSeoOrderListOutput>;
  paginatedSubTaskList?: Maybe<PaginatedSeoOrderListOutput>;
  paginatedSubTaskListCms?: Maybe<PaginatedCmsOrderListOutput>;
  paginatedTransferRequest?: Maybe<PaginatedTransferRequestOutput>;
  paginatedTransferRequestForEmployee?: Maybe<PaginatedTransferRequestOutput>;
  seoOrders?: Maybe<Array<SeoOrders>>;
  userRole: Scalars['String'];
  verifyDomain?: Maybe<VerifyDomainOutput>;
  viewPackage?: Maybe<Array<Package>>;
  viewSubPackage?: Maybe<Array<SubPackage>>;
};


export type QueryAccountTranferLogsForArgs = {
  input?: InputMaybe<AccountTranferQueryForInput>;
};


export type QueryDomainArgs = {
  input?: InputMaybe<DomainIdInput>;
};


export type QueryGenerateContentOrderIdArgs = {
  input?: InputMaybe<GenerateContentOrderIdInput>;
};


export type QueryGetAllNichesForDomainArgs = {
  input?: InputMaybe<DomainIdInput>;
};


export type QueryGetAllPackagesArgs = {
  input?: InputMaybe<PackagesFilter>;
};


export type QueryGetAllSiteContactDetailsForDomainArgs = {
  input?: InputMaybe<DomainIdInput>;
};


export type QueryGetCmsOrderByIdArgs = {
  input?: InputMaybe<CmsOrderIdInput>;
};


export type QueryGetCommentByOrderIdArgs = {
  input?: InputMaybe<GetCommentByOrderIdInput>;
};


export type QueryGetContentOrderArgs = {
  input?: InputMaybe<GetContentOrderInput>;
};


export type QueryGetContentOrderServiceTypeArgs = {
  input?: InputMaybe<GetContentOrderServiceTypeInput>;
};


export type QueryGetContentOrderServiceTypeAttributeArgs = {
  input?: InputMaybe<GetContentOrderServiceTypeAttributeInput>;
};


export type QueryGetContentOrderServiceTypeAttributeValueArgs = {
  input?: InputMaybe<GetContentOrderServiceTypeAttributeValueInput>;
};


export type QueryGetEmployeeByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetEmployeeIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetEmployeeWithRoleArgs = {
  input?: InputMaybe<GetEmployeeWithRoleInput>;
};


export type QueryGetNotificationByIdArgs = {
  input?: InputMaybe<GetNotificationByIdInput>;
};


export type QueryGetOrderByIdArgs = {
  input?: InputMaybe<OrderIdInput>;
};


export type QueryGetOrderGeneratedIdArgs = {
  input?: InputMaybe<GetOrderGeneratedIdInput>;
};


export type QueryGetPackageArgs = {
  id: Scalars['Int'];
};


export type QueryGetPaginatedPotentialSitesForClientArgs = {
  input?: InputMaybe<GetPaginatedPotentialSitesForClientInput>;
};


export type QueryGetSeoOrderByIdArgs = {
  input?: InputMaybe<SeoOrderIdInput>;
};


export type QueryGetSubPackageArgs = {
  id: Scalars['Int'];
};


export type QueryGetTodosByIdArgs = {
  input?: InputMaybe<GetToDoByIdInput>;
};


export type QueryGetTransferRequestArgs = {
  input?: InputMaybe<GetTransferRequestInput>;
};


export type QueryMasterSheetArgs = {
  input?: InputMaybe<GetDomainInput>;
};


export type QueryPaginatedClientSelectedSiteListArgs = {
  input?: InputMaybe<PaginatedClientSelectedSiteListInput>;
};


export type QueryPaginatedCmsAdminOrderListArgs = {
  input?: InputMaybe<PaginatedCmsAdminOrderListInput>;
};


export type QueryPaginatedCmsOrderListArgs = {
  input?: InputMaybe<PaginatedCmsOrderListInput>;
};


export type QueryPaginatedContentOrderListArgs = {
  input?: InputMaybe<PaginatedContentOrderListInput>;
};


export type QueryPaginatedEmployeeListArgs = {
  input?: InputMaybe<PaginateEmpInput>;
};


export type QueryPaginatedMasterSheetArgs = {
  input?: InputMaybe<PaginateDmsInput>;
};


export type QueryPaginatedOrderListArgs = {
  input?: InputMaybe<PaginatedOrderListInput>;
};


export type QueryPaginatedPackageListArgs = {
  input?: InputMaybe<PaginatedPackageInput>;
};


export type QueryPaginatedSeoOrderListArgs = {
  input?: InputMaybe<PaginatedSeoOrderListInput>;
};


export type QueryPaginatedSubTaskListArgs = {
  input?: InputMaybe<PaginatedSubTaskListInput>;
};


export type QueryPaginatedSubTaskListCmsArgs = {
  input?: InputMaybe<PaginatedSubTaskListCmsInput>;
};


export type QueryPaginatedTransferRequestArgs = {
  input?: InputMaybe<PaginatedTransferRequestInput>;
};


export type QueryPaginatedTransferRequestForEmployeeArgs = {
  input?: InputMaybe<PaginatedTransferRequestForEmployeeInput>;
};


export type QueryVerifyDomainArgs = {
  input?: InputMaybe<VerifyDomainInput>;
};


export type QueryViewPackageArgs = {
  input?: InputMaybe<SearchFilter>;
};

export enum Role {
  Admin = 'ADMIN',
  Cmsadmin = 'CMSADMIN',
  Cmsemployee = 'CMSEMPLOYEE',
  Seoadmin = 'SEOADMIN',
  Seoemployee = 'SEOEMPLOYEE'
}

export type ServiceTypes = {
  __typename?: 'ServiceTypes';
  id?: Maybe<Scalars['Int']>;
  serviceType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SiteContactDetails = {
  __typename?: 'SiteContactDetails';
  contactDetails?: Maybe<Scalars['String']>;
  contactType?: Maybe<ContactType>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SiteContactDetailsInput = {
  contactDetails: Scalars['String'];
};

export type Todo = {
  __typename?: 'Todo';
  complete?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['DateTime']>;
  employeeID?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  task?: Maybe<Scalars['String']>;
};

export type ActualDaUpdateInput = {
  actualDA?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type AddContentOrderServiceTypeAttributeInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceTypeID?: InputMaybe<Scalars['Int']>;
};

export type AddEmployee = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  role: Role;
};

export type ArticleLinksUpdateInput = {
  articleLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ClientSiteUrlInput = {
  clientSiteURL?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  requiredDA?: InputMaybe<Scalars['Int']>;
  requiredDR?: InputMaybe<Scalars['Int']>;
};

export type ClientSiteUrlUpdateInput = {
  clientSiteUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CmsOrderIdInput = {
  cmsOrderID?: InputMaybe<Scalars['String']>;
};

export type CmsOrderInput = {
  cmsAdminID?: InputMaybe<Scalars['Int']>;
  dateOfAssignmentCmsAdmin?: InputMaybe<Scalars['DateTime']>;
  instructionCmsAdmin: Scalars['String'];
  orderStatus: Scalars['String'];
};

export type CmsOrders = {
  __typename?: 'cmsOrders';
  Articles?: Maybe<Array<Maybe<ArticleLinks>>>;
  cmsAdmin?: Maybe<Employee>;
  cmsEmp?: Maybe<Employee>;
  dateOfAssignmentCmsAdmin?: Maybe<Scalars['DateTime']>;
  dateOfAssignmentCmsEmployee?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructionCmsAdmin?: Maybe<Scalars['String']>;
  instructionCmsEmp?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  seoOrder?: Maybe<SeoOrders>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Comments = {
  __typename?: 'comments';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  id?: Maybe<Scalars['Int']>;
  orderID?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentOrderArticleLinkInput = {
  articleLink?: InputMaybe<Scalars['String']>;
  contentOrderID?: InputMaybe<Scalars['String']>;
};

export type ContentOrderAssignEmployeeIdInput = {
  contentOrderID?: InputMaybe<Scalars['String']>;
  employeeID?: InputMaybe<Scalars['Int']>;
};

export type CreateContentOrderInput = {
  PbnName?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  clientSiteURL?: InputMaybe<Scalars['String']>;
  cmsAdminID?: InputMaybe<Scalars['Int']>;
  cmsEmployeeID?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  orderDescription?: InputMaybe<Scalars['String']>;
  orderDueDate?: InputMaybe<Scalars['DateTime']>;
  orderStartDate?: InputMaybe<Scalars['DateTime']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  serviceTypeAttributeValue?: InputMaybe<Array<InputMaybe<ContentOrderServiceTypeAttributeValueInput>>>;
  serviceTypeID?: InputMaybe<Scalars['Int']>;
  wordCount?: InputMaybe<Scalars['Int']>;
};

export type CreateContentOrderServiceTypeAttributeInput = {
  attributeName?: InputMaybe<Scalars['String']>;
};

export type CreateContentOrderServiceTypeInput = {
  attributes?: InputMaybe<Array<InputMaybe<CreateContentOrderServiceTypeAttributeInput>>>;
  serviceType?: InputMaybe<Scalars['String']>;
};

export type CreateDomainTransferRequestInput = {
  POC: Scalars['String'];
  ahrefTraffic: Scalars['Int'];
  contactTypeID: Scalars['Int'];
  domainID: Scalars['Int'];
  employeeRequestByID: Scalars['Int'];
  finalPrice: Scalars['Int'];
  linkInsertionPrice: Scalars['Int'];
  priceAsked: Scalars['Int'];
  siteDA: Scalars['Int'];
  siteDR: Scalars['Int'];
  siteTraffic: Scalars['Int'];
  specialPrice: Scalars['Int'];
  status: Scalars['String'];
};

export type CreateMasterSheetInput = {
  comments?: InputMaybe<Scalars['String']>;
  domain: DomainMasterSheetInput;
  domainDetails?: InputMaybe<DomainDetailsInput>;
  niches: Array<InputMaybe<Scalars['String']>>;
  siteContactDetails?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateNiche = {
  niche: Scalars['String'];
  nicheAbbr: Scalars['String'];
};

export type CreateNicheInput = {
  niches?: InputMaybe<Array<InputMaybe<CreateNiche>>>;
};

export type DisableEmployeeInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type DisablePackageInput = {
  id: Scalars['Int'];
  isDisabled: Scalars['Boolean'];
};

export type DomainContactTypeFilter = {
  admin?: InputMaybe<Scalars['Boolean']>;
  thirdParty?: InputMaybe<Scalars['Boolean']>;
};

export type DomainIdInput = {
  id: Scalars['Int'];
};

export type DomainMasterSheetInput = {
  ahrefTraffic: Scalars['Int'];
  siteDA: Scalars['Int'];
  siteDR: Scalars['Int'];
  siteTraffic: Scalars['Int'];
  siteUrl: Scalars['String'];
};

export type DomainServiceTypeFilter = {
  guestPost?: InputMaybe<Scalars['Boolean']>;
  linkInsertion?: InputMaybe<Scalars['Boolean']>;
};

export type DomainStatusFilter = {
  done?: InputMaybe<Scalars['Boolean']>;
  negotiating?: InputMaybe<Scalars['Boolean']>;
};

export type EnableEmployeeInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type GenerateContentOrderIdInput = {
  clientName?: InputMaybe<Scalars['String']>;
};

export type GetCommentByOrderIdInput = {
  orderID?: InputMaybe<Scalars['String']>;
};

export type GetContentOrderInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GetContentOrderServiceTypeAttributeInput = {
  serviceTypeID?: InputMaybe<Scalars['Int']>;
};

export type GetContentOrderServiceTypeAttributeValueInput = {
  contentOrderID?: InputMaybe<Scalars['String']>;
};

export type GetContentOrderServiceTypeInput = {
  serviceTypeID?: InputMaybe<Scalars['Int']>;
};

export type GetCounts = {
  __typename?: 'getCounts';
  doneDMSCounts?: Maybe<Scalars['Int']>;
  negotiatingDMSCounts?: Maybe<Scalars['Int']>;
  outreachedDMSCounts?: Maybe<Scalars['Int']>;
};

export type GetDomainInput = {
  contactTypeID: Scalars['Int'];
  id: Scalars['Int'];
};

export type GetEmployeeWithRoleInput = {
  role?: InputMaybe<Array<InputMaybe<Role>>>;
};

export type GetNotificationByIdInput = {
  toEmployeeID?: InputMaybe<Scalars['Int']>;
};

export type GetOrderGeneratedIdInput = {
  clientName?: InputMaybe<Scalars['String']>;
  orderTypeID?: InputMaybe<Scalars['Int']>;
};

export type GetPaginatedPotentialSitesForClientInput = {
  ahrefTrafficFilter?: InputMaybe<RangeFilterInteger>;
  clientID?: InputMaybe<Scalars['Int']>;
  contactTypeFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateOfContactFilter?: InputMaybe<RangeFilterDateAsString>;
  finalPriceFilter?: InputMaybe<RangeFilterInteger>;
  nicheFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceAskedFilter?: InputMaybe<RangeFilterInteger>;
  search?: InputMaybe<SearchFilter>;
  serviceTypeFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteDaFilter?: InputMaybe<RangeFilterInteger>;
  siteDrFilter?: InputMaybe<RangeFilterInteger>;
  siteTrafficFilter?: InputMaybe<RangeFilterInteger>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  specialPriceFilter?: InputMaybe<RangeFilterInteger>;
  statusFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type GetToDoByIdInput = {
  employeeID?: InputMaybe<Scalars['Int']>;
};

export type GetTransferRequestInput = {
  requestID?: InputMaybe<Scalars['Int']>;
};

export type KeywordUpdateInput = {
  id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
};

export type LiveLinks = {
  __typename?: 'liveLinks';
  id?: Maybe<Scalars['Int']>;
  liveLinks?: Maybe<Scalars['String']>;
  seoOrderID?: Maybe<Scalars['String']>;
};

export type LiveLinksUpdateInput = {
  id?: InputMaybe<Scalars['Int']>;
  liveLink?: InputMaybe<Scalars['String']>;
};

export type LoginEmployeeInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'loginResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MainOrderInput = {
  ArticleCounts: Scalars['Int'];
  DAorDR: Scalars['String'];
  clientSiteURL: Scalars['String'];
  id: Scalars['String'];
  orderCreatedByID: Scalars['Int'];
  orderDueDate: Scalars['DateTime'];
  orderStartDate: Scalars['DateTime'];
  orderStatus: Scalars['String'];
  orderTypeID: Scalars['Int'];
  packageID?: InputMaybe<Scalars['Int']>;
  paymentStatus: Scalars['String'];
  requiredDA: Scalars['Int'];
  requiredDR: Scalars['Int'];
  seoOrderManagerID?: InputMaybe<Scalars['Int']>;
};

export type MainOrders = {
  __typename?: 'mainOrders';
  ArticleCounts?: Maybe<Scalars['Int']>;
  SeoOrders?: Maybe<Array<Maybe<SeoOrders>>>;
  client?: Maybe<Client>;
  clientSiteURL?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Employee>;
  id?: Maybe<Scalars['String']>;
  orderDueDate?: Maybe<Scalars['DateTime']>;
  orderStartDate?: Maybe<Scalars['DateTime']>;
  orderStatus?: Maybe<Scalars['String']>;
  package?: Maybe<Package>;
  paymentStatus?: Maybe<Scalars['String']>;
  requiredDA?: Maybe<Scalars['Int']>;
  requiredDR?: Maybe<Scalars['Int']>;
  seoOrderManager?: Maybe<Employee>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MarkTodoComplteIncompleteInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type MinMaxPrice = {
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
};

export type MutationResponse = {
  __typename?: 'mutationResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type NewCommentInput = {
  description?: InputMaybe<Scalars['String']>;
  employeeID?: InputMaybe<Scalars['Int']>;
  orderID?: InputMaybe<Scalars['String']>;
};

export type NichesInput = {
  niche: Scalars['String'];
};

export type NotificationInput = {
  description?: InputMaybe<Scalars['String']>;
  fromEmployeeID?: InputMaybe<Scalars['Int']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  toEmployeeID?: InputMaybe<Scalars['Int']>;
};

export type OrderIdInput = {
  orderID: Scalars['String'];
};

export type OrderStatusFilter = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  done?: InputMaybe<Scalars['Boolean']>;
  issueRaised?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  processing?: InputMaybe<Scalars['Boolean']>;
};

export type OrderType = {
  __typename?: 'orderType';
  id?: Maybe<Scalars['Int']>;
  initials?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
};

export type Package = {
  __typename?: 'package';
  SubPackage?: Maybe<Array<Maybe<SubPackage>>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  packageName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

export type PackagesFilter = {
  description?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  packageName?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<MinMaxPrice>;
};

export type PaginateDmsInput = {
  ahrefTrafficFilter?: InputMaybe<RangeFilterInteger>;
  contactTypeFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateOfContactFilter?: InputMaybe<RangeFilterDateAsString>;
  finalPriceFilter?: InputMaybe<RangeFilterInteger>;
  forEmployeeID?: InputMaybe<Scalars['Int']>;
  nicheFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceAskedFilter?: InputMaybe<RangeFilterInteger>;
  search?: InputMaybe<SearchFilter>;
  serviceTypeFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteDaFilter?: InputMaybe<RangeFilterInteger>;
  siteDrFilter?: InputMaybe<RangeFilterInteger>;
  siteTrafficFilter?: InputMaybe<RangeFilterInteger>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  specialPriceFilter?: InputMaybe<RangeFilterInteger>;
  statusFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginateEmpInput = {
  roleFilters?: InputMaybe<Array<InputMaybe<Role>>>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedClientSelectedSiteListInput = {
  orderID?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedClientSelectedSiteListOutput = {
  __typename?: 'paginatedClientSelectedSiteListOutput';
  siteUrls?: Maybe<Array<Maybe<ClientSelectedSite>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type PaginatedCmsAdminOrderListInput = {
  articleCountsFilter?: InputMaybe<RangeFilterInteger>;
  cmsAdminID?: InputMaybe<Scalars['Int']>;
  dueDateFilter?: InputMaybe<RangeFilterDateAsString>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedCmsOrderListInput = {
  articleCountsFilter?: InputMaybe<RangeFilterInteger>;
  dueDateFilter?: InputMaybe<RangeFilterDateAsString>;
  forEmployeeID?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedCmsOrderListOutput = {
  __typename?: 'paginatedCmsOrderListOutput';
  cmsOrderList: Array<Maybe<CmsOrders>>;
  totalPages: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type PaginatedContentOrderListInput = {
  dueDateFilter?: InputMaybe<RangeFilterDateAsString>;
  forEmployeeID?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  statusFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
  wordCountFilter?: InputMaybe<RangeFilterInteger>;
};

export type PaginatedContentOrderListOutput = {
  __typename?: 'paginatedContentOrderListOutput';
  contentOrders: Array<Maybe<ContentOrder>>;
  totalPages: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type PaginatedDmsOutput = {
  __typename?: 'paginatedDMSOutput';
  dms?: Maybe<Array<Maybe<MasterSheet>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type PaginatedEmpOutput = {
  __typename?: 'paginatedEmpOutput';
  emplo?: Maybe<Array<Maybe<Employee>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type PaginatedOrderListInput = {
  articleCountsFilter?: InputMaybe<RangeFilterInteger>;
  dueDateFilter?: InputMaybe<RangeFilterDateAsString>;
  forEmployeeID?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SearchFilter>;
  siteDaReq?: InputMaybe<RangeFilterInteger>;
  siteDrReq?: InputMaybe<RangeFilterInteger>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedOrderListOutput = {
  __typename?: 'paginatedOrderListOutput';
  orderList: Array<Maybe<MainOrders>>;
  totalPages: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type PaginatedPackageInput = {
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedPackageOutput = {
  __typename?: 'paginatedPackageOutput';
  pack?: Maybe<Array<Maybe<Package>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type PaginatedSeoOrderListInput = {
  articleCountsFilter?: InputMaybe<RangeFilterInteger>;
  dueDateFilter?: InputMaybe<RangeFilterDateAsString>;
  forEmployeeID?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SearchFilter>;
  siteDaReq?: InputMaybe<RangeFilterInteger>;
  siteDrReq?: InputMaybe<RangeFilterInteger>;
  skip?: InputMaybe<Scalars['Int']>;
  statusFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedSeoOrderListOutput = {
  __typename?: 'paginatedSeoOrderListOutput';
  seoOrderList: Array<Maybe<SeoOrders>>;
  totalPages: Scalars['Int'];
  totalRows: Scalars['Int'];
};

export type PaginatedSubTaskListCmsInput = {
  orderID?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedSubTaskListInput = {
  orderID?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<SearchFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedTransferRequestForEmployeeInput = {
  employeeID?: InputMaybe<Scalars['Int']>;
  inOrOut?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedTransferRequestInput = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginatedTransferRequestOutput = {
  __typename?: 'paginatedTransferRequestOutput';
  requests?: Maybe<Array<Maybe<DomainTransferRequest>>>;
  totalPages?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
};

export type QueryResponse = {
  __typename?: 'queryResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RangeFilterDate = {
  gte?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type RangeFilterDateAsString = {
  gte?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
};

export type RangeFilterInteger = {
  gte?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
};

export type RoleFilter = {
  ADMIN?: InputMaybe<Scalars['Boolean']>;
  CMSADMIN?: InputMaybe<Scalars['Boolean']>;
  CMSEMPLOYEE?: InputMaybe<Scalars['Boolean']>;
  SEOADMIN?: InputMaybe<Scalars['Boolean']>;
  SEOEMPLOYEE?: InputMaybe<Scalars['Boolean']>;
};

export type SearchFilter = {
  contains?: InputMaybe<Scalars['String']>;
};

export type SelectedSiteUpdateInput = {
  id?: InputMaybe<Scalars['String']>;
  selectedSite?: InputMaybe<Scalars['String']>;
};

export type SeoOrderIdInput = {
  seoOrderID?: InputMaybe<Scalars['String']>;
};

export type SeoOrderInput = {
  dateOfAssignment?: InputMaybe<Scalars['DateTime']>;
  instructionsSeoEmployee: Scalars['String'];
  orderID?: InputMaybe<Scalars['String']>;
  orderStatus: Scalars['String'];
  seoEmpID?: InputMaybe<Scalars['Int']>;
};

export type SeoOrders = {
  __typename?: 'seoOrders';
  ClientSiteUrl?: Maybe<Array<Maybe<ClientSiteUrl>>>;
  CmsOrders?: Maybe<Array<Maybe<CmsOrders>>>;
  LiveLinks?: Maybe<Array<Maybe<LiveLinks>>>;
  actualDA?: Maybe<Scalars['Int']>;
  dateOfAssignment?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  instructionsSeoEmployee?: Maybe<Scalars['String']>;
  order?: Maybe<MainOrders>;
  orderStatus?: Maybe<Scalars['String']>;
  selectedSite?: Maybe<Scalars['String']>;
  seoEmp?: Maybe<Employee>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SetPassword = {
  id?: InputMaybe<Scalars['Int']>;
  password: Scalars['String'];
};

export type SubPackage = {
  __typename?: 'subPackage';
  id?: Maybe<Scalars['Int']>;
  packageDescription?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  requiredDA?: Maybe<Scalars['String']>;
  subPackageName?: Maybe<Scalars['String']>;
};

export type SubPackageInput = {
  packageDescription: Scalars['String'];
  packageId: Scalars['Int'];
  price: Scalars['Int'];
  requiredDA: Scalars['String'];
  subPackageName?: InputMaybe<Scalars['String']>;
};

export type SubTaskReAssignInput = {
  id?: InputMaybe<Scalars['String']>;
  seoEmpID?: InputMaybe<Scalars['Int']>;
};

export type SubTaskReAssignInputCms = {
  cmsEmpID?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ToDoInput = {
  complete?: InputMaybe<Scalars['Boolean']>;
  employeeID?: InputMaybe<Scalars['Int']>;
  task?: InputMaybe<Scalars['String']>;
};

export type TransferAccountOwnerInput = {
  id: Scalars['Int'];
  newOwnerId: Scalars['Int'];
};

export type UpdateCmsOrder = {
  cmsAdminID?: InputMaybe<Scalars['Int']>;
  cmsEmpID?: InputMaybe<Scalars['Int']>;
  dateOfAssignmentCmsAdmin?: InputMaybe<Scalars['DateTime']>;
  dateOfAssignmentCmsEmployee?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructionCmsAdmin?: InputMaybe<Scalars['String']>;
  instructionCmsEmp?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateCommentInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdateContactDetailsInput = {
  contactDetails?: InputMaybe<Scalars['String']>;
  contactTypeID: Scalars['Int'];
};

export type UpdateContentOrderInput = {
  PbnName?: InputMaybe<Scalars['String']>;
  clientID?: InputMaybe<Scalars['Int']>;
  clientSiteURL?: InputMaybe<Scalars['String']>;
  cmsAdminID?: InputMaybe<Scalars['Int']>;
  cmsEmployeeID?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  orderDescription?: InputMaybe<Scalars['String']>;
  orderDueDate?: InputMaybe<Scalars['DateTime']>;
  orderStartDate?: InputMaybe<Scalars['DateTime']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  serviceTypeID?: InputMaybe<Scalars['Int']>;
  wordCount?: InputMaybe<Scalars['Int']>;
};

export type UpdateContentOrderServiceTypeAttributeInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  serviceTypeID?: InputMaybe<Scalars['Int']>;
};

export type UpdateContentOrderServiceTypeAttributeStatusInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdateContentOrderServiceTypeInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  serviceType?: InputMaybe<Scalars['String']>;
};

export type UpdateContentOrderServiceTypeStatusInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdateContentOrderStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateDomainDetailStatusInput = {
  contactTypeID?: InputMaybe<Scalars['Int']>;
  domainID?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateDomainDetailsInput = {
  POC?: InputMaybe<Scalars['String']>;
  contactTypeID: Scalars['Int'];
  finalPrice?: InputMaybe<Scalars['Int']>;
  linkInsertionPrice?: InputMaybe<Scalars['Int']>;
  priceAsked?: InputMaybe<Scalars['Int']>;
  specialPrice?: InputMaybe<Scalars['Int']>;
};

export type UpdateDomainInput = {
  ahrefTraffic?: InputMaybe<Scalars['Int']>;
  domainDetails?: InputMaybe<Array<InputMaybe<UpdateDomainDetailsInput>>>;
  domainID: Scalars['Int'];
  niches?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteContactDetails?: InputMaybe<Array<InputMaybe<UpdateContactDetailsInput>>>;
  siteDA?: InputMaybe<Scalars['Int']>;
  siteDR?: InputMaybe<Scalars['Int']>;
  siteTraffic?: InputMaybe<Scalars['Int']>;
};

export type UpdateDomainTransferRequestInput = {
  POC?: InputMaybe<Scalars['String']>;
  ahrefTraffic?: InputMaybe<Scalars['Int']>;
  finalPrice?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  priceAsked?: InputMaybe<Scalars['Int']>;
  siteDA?: InputMaybe<Scalars['Int']>;
  siteDR?: InputMaybe<Scalars['Int']>;
  siteTraffic?: InputMaybe<Scalars['Int']>;
  specialPrice?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateEmployee = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
};

export type UpdateMainOrder = {
  DAorDR?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  orderDueDate?: InputMaybe<Scalars['DateTime']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  requiredDA?: InputMaybe<Scalars['Int']>;
};

export type UpdateMainOrderStatusInput = {
  orderID?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateNicheInput = {
  id?: InputMaybe<Scalars['Int']>;
  niche?: InputMaybe<Scalars['String']>;
  nicheAbbr?: InputMaybe<Scalars['String']>;
};

export type UpdateNicheStatusInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdateNotificationInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type UpdatePackage = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  packageName?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type UpdatePassword = {
  id?: InputMaybe<Scalars['Int']>;
  password: Scalars['String'];
};

export type UpdateSeoOrder = {
  dateOfAssignment?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  instructionsSeoEmployee?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  seoEmpID?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateSeoOrderManagerInput = {
  newSeoOrderManagerID?: InputMaybe<Scalars['Int']>;
  orderID?: InputMaybe<Scalars['String']>;
};

export type UpdateSubPackage = {
  id: Scalars['Int'];
  packageDescription?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredDA?: InputMaybe<Scalars['String']>;
  subPackageName?: InputMaybe<Scalars['String']>;
};

export type UpdateTodoInput = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type VerifyDomainInput = {
  contactTypeID?: InputMaybe<Scalars['Int']>;
  siteUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyDomainOutput = {
  __typename?: 'verifyDomainOutput';
  ahrefTraffic?: Maybe<Scalars['Int']>;
  contactTypeID?: Maybe<Scalars['Int']>;
  contactedBy?: Maybe<Employee>;
  domainID?: Maybe<Scalars['Int']>;
  finalPrice?: Maybe<Scalars['Int']>;
  priceAsked?: Maybe<Scalars['Int']>;
  serviceType?: Maybe<Scalars['String']>;
  serviceTypeID?: Maybe<Scalars['Int']>;
  siteDA?: Maybe<Scalars['Int']>;
  siteDR?: Maybe<Scalars['Int']>;
  siteTraffic?: Maybe<Scalars['Int']>;
  specialPrice?: Maybe<Scalars['Int']>;
  verified: Scalars['Boolean'];
};

export type ViewOrderUpdateInput = {
  actualDA?: InputMaybe<Array<InputMaybe<ActualDaUpdateInput>>>;
  articleLinks?: InputMaybe<Array<InputMaybe<ArticleLinksUpdateInput>>>;
  clientSiteUrl?: InputMaybe<Array<InputMaybe<ClientSiteUrlUpdateInput>>>;
  keyword?: InputMaybe<Array<InputMaybe<KeywordUpdateInput>>>;
  liveLinks?: InputMaybe<Array<InputMaybe<LiveLinksUpdateInput>>>;
  selectedSite?: InputMaybe<Array<InputMaybe<SelectedSiteUpdateInput>>>;
  subTask?: InputMaybe<Array<InputMaybe<SubTaskReAssignInput>>>;
};

export type ViewOrderUpdateInputCms = {
  articleLinks?: InputMaybe<Array<InputMaybe<ArticleLinksUpdateInput>>>;
  clientSiteUrl?: InputMaybe<Array<InputMaybe<ClientSiteUrlUpdateInput>>>;
  keyword?: InputMaybe<Array<InputMaybe<KeywordUpdateInput>>>;
  liveLinks?: InputMaybe<Array<InputMaybe<LiveLinksUpdateInput>>>;
  subTask?: InputMaybe<Array<InputMaybe<SubTaskReAssignInputCms>>>;
};

export type AccountTransferMutationVariables = Exact<{
  input?: InputMaybe<AccountTransferInput>;
}>;


export type AccountTransferMutation = { __typename?: 'Mutation', accountTransfer?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AddNewCommentMutationVariables = Exact<{
  input: NewCommentInput;
}>;


export type AddNewCommentMutation = { __typename?: 'Mutation', addNewComment?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type CreateContentOrderServiceTypeMutationVariables = Exact<{
  input?: InputMaybe<CreateContentOrderServiceTypeInput>;
}>;


export type CreateContentOrderServiceTypeMutation = { __typename?: 'Mutation', createContentOrderServiceType?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type CreateContentOrderMutationVariables = Exact<{
  input?: InputMaybe<CreateContentOrderInput>;
}>;


export type CreateContentOrderMutation = { __typename?: 'Mutation', createContentOrder?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateContentOrderServiceTypeStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateContentOrderServiceTypeStatusInput>;
}>;


export type UpdateContentOrderServiceTypeStatusMutation = { __typename?: 'Mutation', updateContentOrderServiceTypeStatus?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AssignCmsAdminMutationVariables = Exact<{
  input?: InputMaybe<ContentOrderAssignEmployeeIdInput>;
}>;


export type AssignCmsAdminMutation = { __typename?: 'Mutation', assignCMSAdmin?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AssignCmsEmployeeMutationVariables = Exact<{
  input?: InputMaybe<ContentOrderAssignEmployeeIdInput>;
}>;


export type AssignCmsEmployeeMutation = { __typename?: 'Mutation', assignCMSEmployee?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type ContentOrderArticleLinkMutationVariables = Exact<{
  input?: InputMaybe<ContentOrderArticleLinkInput>;
}>;


export type ContentOrderArticleLinkMutation = { __typename?: 'Mutation', contentOrderArticleLink?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateContentOrderMutationVariables = Exact<{
  input?: InputMaybe<UpdateContentOrderInput>;
}>;


export type UpdateContentOrderMutation = { __typename?: 'Mutation', updateContentOrder?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type UpdateContentOrderStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateContentOrderStatusInput>;
}>;


export type UpdateContentOrderStatusMutation = { __typename?: 'Mutation', updateContentOrderStatus?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type CreateOrderMutationVariables = Exact<{
  input: OrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type CreateNicheMutationVariables = Exact<{
  input?: InputMaybe<CreateNicheInput>;
}>;


export type CreateNicheMutation = { __typename?: 'Mutation', createNiche?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateNicheStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateNicheStatusInput>;
}>;


export type UpdateNicheStatusMutation = { __typename?: 'Mutation', updateNicheStatus?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateSeoOrdersMutationVariables = Exact<{
  input: UpdateSeoOrder;
}>;


export type UpdateSeoOrdersMutation = { __typename?: 'Mutation', updateSeoOrders?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateMainOrdersMutationVariables = Exact<{
  input: UpdateMainOrder;
}>;


export type UpdateMainOrdersMutation = { __typename?: 'Mutation', updateMainOrders?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type ViewOrderUpdateMutationVariables = Exact<{
  input?: InputMaybe<ViewOrderUpdateInput>;
}>;


export type ViewOrderUpdateMutation = { __typename?: 'Mutation', viewOrderUpdate?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type ViewOrderUpdateCmsMutationVariables = Exact<{
  input?: InputMaybe<ViewOrderUpdateInputCms>;
}>;


export type ViewOrderUpdateCmsMutation = { __typename?: 'Mutation', viewOrderUpdateCms?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateSeoOrderManagerMutationVariables = Exact<{
  input?: InputMaybe<UpdateSeoOrderManagerInput>;
}>;


export type UpdateSeoOrderManagerMutation = { __typename?: 'Mutation', updateSeoOrderManager?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateMainOrderStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateMainOrderStatusInput>;
}>;


export type UpdateMainOrderStatusMutation = { __typename?: 'Mutation', updateMainOrderStatus?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type CreateDomainTransferRequestMutationVariables = Exact<{
  input?: InputMaybe<CreateDomainTransferRequestInput>;
}>;


export type CreateDomainTransferRequestMutation = { __typename?: 'Mutation', createDomainTransferRequest?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type AcceptDomainTransferRequestMutationVariables = Exact<{
  input?: InputMaybe<DomainTransferRequestStatusInput>;
}>;


export type AcceptDomainTransferRequestMutation = { __typename?: 'Mutation', acceptDomainTransferRequest?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type RejectDomainTransferRequestMutationVariables = Exact<{
  input?: InputMaybe<DomainTransferRequestStatusInput>;
}>;


export type RejectDomainTransferRequestMutation = { __typename?: 'Mutation', rejectDomainTransferRequest?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateDomainDetailStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateDomainDetailStatusInput>;
}>;


export type UpdateDomainDetailStatusMutation = { __typename?: 'Mutation', updateDomainDetailStatus?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateDomainMutationVariables = Exact<{
  input?: InputMaybe<UpdateDomainInput>;
}>;


export type UpdateDomainMutation = { __typename?: 'Mutation', updateDomain?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type CreateMasterSheetMutationVariables = Exact<{
  input?: InputMaybe<CreateMasterSheetInput>;
}>;


export type CreateMasterSheetMutation = { __typename?: 'Mutation', createMasterSheet?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AddEmployeeMutationVariables = Exact<{
  input?: InputMaybe<AddEmployee>;
}>;


export type AddEmployeeMutation = { __typename?: 'Mutation', addEmployee?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input?: InputMaybe<UpdatePassword>;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'mutationResponse', message: string, success: boolean, token?: string | null } | null };

export type UpdateEmployeeMutationVariables = Exact<{
  input?: InputMaybe<UpdateEmployee>;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee?: { __typename?: 'mutationResponse', message: string, success: boolean, token?: string | null } | null };

export type DisableEmployeeMutationVariables = Exact<{
  input?: InputMaybe<DisableEmployeeInput>;
}>;


export type DisableEmployeeMutation = { __typename?: 'Mutation', disableEmployee?: { __typename?: 'mutationResponse', success: boolean, message: string } | null };

export type EnableEmployeeMutationVariables = Exact<{
  input?: InputMaybe<EnableEmployeeInput>;
}>;


export type EnableEmployeeMutation = { __typename?: 'Mutation', enableEmployee?: { __typename?: 'mutationResponse', message: string, success: boolean } | null };

export type UpdateNotificationMutationVariables = Exact<{
  input?: InputMaybe<UpdateNotificationInput>;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type LoginEmployeeMutationVariables = Exact<{
  input?: InputMaybe<LoginEmployeeInput>;
}>;


export type LoginEmployeeMutation = { __typename?: 'Mutation', loginEmployee?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AddTodoMutationVariables = Exact<{
  input?: InputMaybe<ToDoInput>;
}>;


export type AddTodoMutation = { __typename?: 'Mutation', addTodo?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateTodoMutationVariables = Exact<{
  input?: InputMaybe<UpdateTodoInput>;
}>;


export type UpdateTodoMutation = { __typename?: 'Mutation', updateTodo?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  input?: InputMaybe<ForgotPasswordInput>;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AddNewPackageMutationVariables = Exact<{
  input: NewPackage;
}>;


export type AddNewPackageMutation = { __typename?: 'Mutation', addNewPackage?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type AddSubPackageMutationVariables = Exact<{
  input: SubPackageInput;
}>;


export type AddSubPackageMutation = { __typename?: 'Mutation', addSubPackage?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdatePackageMutationVariables = Exact<{
  input: UpdatePackage;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type UpdateSubPackageMutationVariables = Exact<{
  input: UpdateSubPackage;
}>;


export type UpdateSubPackageMutation = { __typename?: 'Mutation', updateSubPackage?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type DisablePackageMutationVariables = Exact<{
  input: DisablePackageInput;
}>;


export type DisablePackageMutation = { __typename?: 'Mutation', disablePackage?: { __typename?: 'mutationResponse', success: boolean, message: string, token?: string | null } | null };

export type GetCommentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommentQuery = { __typename?: 'Query', getComment?: Array<{ __typename?: 'comments', id?: number | null, orderID?: string | null, description?: string | null, createdAt?: any | null, updatedAt?: any | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null, id?: number | null } | null } | null> | null };

export type GetCommentByOrderIdQueryVariables = Exact<{
  input?: InputMaybe<GetCommentByOrderIdInput>;
}>;


export type GetCommentByOrderIdQuery = { __typename?: 'Query', getCommentByOrderID?: Array<{ __typename?: 'comments', id?: number | null, orderID?: string | null, description?: string | null, createdAt?: any | null, updatedAt?: any | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null, createdAt?: any | null } | null } | null> | null };

export type GetContentOrderServiceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentOrderServiceTypesQuery = { __typename?: 'Query', getContentOrderServiceTypes?: Array<{ __typename?: 'ContentOrderServiceType', id?: number | null, serviceType?: string | null, disabled?: boolean | null, ContentOrderServiceTypeAttribute?: Array<{ __typename?: 'ContentOrderServiceTypeAttribute', attributeName?: string | null, id?: number | null, disabled?: boolean | null } | null> | null } | null> | null };

export type GetAllContentOrderServiceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContentOrderServiceTypesQuery = { __typename?: 'Query', getAllContentOrderServiceTypes?: Array<{ __typename?: 'ContentOrderServiceType', id?: number | null, serviceType?: string | null, disabled?: boolean | null, ContentOrderServiceTypeAttribute?: Array<{ __typename?: 'ContentOrderServiceTypeAttribute', attributeName?: string | null, id?: number | null, disabled?: boolean | null } | null> | null } | null> | null };

export type GenerateContentOrderIdQueryVariables = Exact<{
  input?: InputMaybe<GenerateContentOrderIdInput>;
}>;


export type GenerateContentOrderIdQuery = { __typename?: 'Query', generateContentOrderID?: string | null };

export type GetContentOrderServiceTypeAttributeQueryVariables = Exact<{
  input?: InputMaybe<GetContentOrderServiceTypeAttributeInput>;
}>;


export type GetContentOrderServiceTypeAttributeQuery = { __typename?: 'Query', getContentOrderServiceTypeAttribute?: Array<{ __typename?: 'ContentOrderServiceTypeAttribute', attributeName?: string | null, id?: number | null, disabled?: boolean | null } | null> | null };

export type PaginatedContentOrderListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedContentOrderListInput>;
}>;


export type PaginatedContentOrderListQuery = { __typename?: 'Query', paginatedContentOrderList?: { __typename?: 'paginatedContentOrderListOutput', totalPages: number, totalRows: number, contentOrders: Array<{ __typename?: 'ContentOrder', id?: string | null, PbnName?: string | null, clientSiteURL?: string | null, wordCount?: number | null, orderStatus?: string | null, orderStartDate?: any | null, orderDueDate?: any | null, orderDescription?: string | null, cmsEmployeeID?: number | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null } | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null } | null, cmsEmployee?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null } | null, serviceType?: { __typename?: 'ContentOrderServiceType', ContentOrderServiceTypeAttribute?: Array<{ __typename?: 'ContentOrderServiceTypeAttribute', disabled?: boolean | null, attributeName?: string | null, serviceTypeID?: number | null, serviceType?: { __typename?: 'ContentOrderServiceType', id?: number | null, serviceType?: string | null, disabled?: boolean | null } | null } | null> | null } | null } | null> } | null };

export type GetContentOrderQueryVariables = Exact<{
  input?: InputMaybe<GetContentOrderInput>;
}>;


export type GetContentOrderQuery = { __typename?: 'Query', getContentOrder?: { __typename?: 'ContentOrder', id?: string | null, PbnName?: string | null, clientSiteURL?: string | null, wordCount?: number | null, orderStatus?: string | null, orderStartDate?: any | null, orderDueDate?: any | null, orderDescription?: string | null, articleLink?: string | null, serviceTypeID?: number | null, clientID?: number | null, cmsAdminID?: number | null, cmsEmployeeID?: number | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null } | null, cmsEmployee?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, role?: Role | null, phone?: string | null } | null, cmsAdmin?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, role?: Role | null, phone?: string | null } | null, contentOrderServiceTypeAttributeValue?: Array<{ __typename?: 'ContentOrderServiceTypeAttributeValue', serviceTypeAttributeValue?: string | null, serviceTypeAttribute?: { __typename?: 'ContentOrderServiceTypeAttribute', attributeName?: string | null, disabled?: boolean | null, id?: number | null, serviceType?: { __typename?: 'ContentOrderServiceType', id?: number | null, serviceType?: string | null, disabled?: boolean | null } | null } | null } | null> | null } | null };

export type PaginatedTransferRequestForEmployeeQueryVariables = Exact<{
  input?: InputMaybe<PaginatedTransferRequestForEmployeeInput>;
}>;


export type PaginatedTransferRequestForEmployeeQuery = { __typename?: 'Query', paginatedTransferRequestForEmployee?: { __typename?: 'paginatedTransferRequestOutput', totalPages?: number | null, totalRows?: number | null, requests?: Array<{ __typename?: 'DomainTransferRequest', id?: number | null, siteDA?: number | null, siteDR?: number | null, siteTraffic?: number | null, priceAsked?: number | null, finalPrice?: number | null, specialPrice?: number | null, POC?: string | null, status?: string | null, createdAt?: any | null, domain?: { __typename?: 'MasterSheet', id: number, siteDA: number, siteDR: number, siteTraffic: number, siteUrl: string, domainDetails: Array<{ __typename?: 'DomainDetails', POC: string, finalPrice: number, linkInsertionPrice?: number | null, priceAsked: number, specialPrice: number, status: string, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null }, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null }, serviceType: { __typename?: 'ServiceTypes', serviceType?: string | null, id?: number | null } } | null> } | null, employeeRequestBy?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null } | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null> | null } | null };

export type PaginatedTransferRequestQueryVariables = Exact<{
  input?: InputMaybe<PaginatedTransferRequestInput>;
}>;


export type PaginatedTransferRequestQuery = { __typename?: 'Query', paginatedTransferRequest?: { __typename?: 'paginatedTransferRequestOutput', totalPages?: number | null, totalRows?: number | null, requests?: Array<{ __typename?: 'DomainTransferRequest', id?: number | null, siteDA?: number | null, siteDR?: number | null, siteTraffic?: number | null, priceAsked?: number | null, finalPrice?: number | null, specialPrice?: number | null, POC?: string | null, status?: string | null, domain?: { __typename?: 'MasterSheet', id: number, siteDA: number, siteDR: number, siteTraffic: number, siteUrl: string, domainDetails: Array<{ __typename?: 'DomainDetails', POC: string, finalPrice: number, linkInsertionPrice?: number | null, priceAsked: number, specialPrice: number, status: string, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null }, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null }, serviceType: { __typename?: 'ServiceTypes', serviceType?: string | null, id?: number | null } } | null> } | null, employeeRequestBy?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null } | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null> | null } | null };

export type GetTransferRequestQueryVariables = Exact<{
  input?: InputMaybe<GetTransferRequestInput>;
}>;


export type GetTransferRequestQuery = { __typename?: 'Query', getTransferRequest?: { __typename?: 'DomainTransferRequest', id?: number | null, siteDA?: number | null, siteDR?: number | null, siteTraffic?: number | null, priceAsked?: number | null, finalPrice?: number | null, specialPrice?: number | null, linkInsertionPrice?: number | null, POC?: string | null, status?: string | null, createdAt?: any | null, domain?: { __typename?: 'MasterSheet', id: number, siteDA: number, siteDR: number, siteTraffic: number, siteUrl: string, domainDetails: Array<{ __typename?: 'DomainDetails', POC: string, finalPrice: number, linkInsertionPrice?: number | null, priceAsked: number, specialPrice: number, status: string, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null }, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null }, serviceType: { __typename?: 'ServiceTypes', serviceType?: string | null, id?: number | null } } | null>, DomainNiches: Array<{ __typename?: 'DomainNiche', niche?: { __typename?: 'Niche', niche?: string | null, id?: number | null, nicheAbbr?: string | null } | null } | null>, siteContactDetails: Array<{ __typename?: 'SiteContactDetails', contactDetails?: string | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null> } | null, employeeRequestBy?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, role?: Role | null } | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null };

export type GetEmployeeWithRoleQueryVariables = Exact<{
  input?: InputMaybe<GetEmployeeWithRoleInput>;
}>;


export type GetEmployeeWithRoleQuery = { __typename?: 'Query', getEmployeeWithRole?: Array<{ __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, role?: Role | null } | null> | null };

export type GetEmployeeByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetEmployeeByEmailQuery = { __typename?: 'Query', getEmployeeByEmail?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null };

export type GetTodosQueryVariables = Exact<{
  input?: InputMaybe<GetToDoByIdInput>;
}>;


export type GetTodosQuery = { __typename?: 'Query', getTodosById?: Array<{ __typename?: 'Todo', id?: number | null, task?: string | null, complete?: boolean | null, employeeID?: number | null, date?: any | null } | null> | null };

export type GetNichesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNichesQuery = { __typename?: 'Query', getNiches?: Array<{ __typename?: 'Niche', id?: number | null, niche?: string | null, nicheAbbr?: string | null, disabled?: boolean | null } | null> | null };

export type AllNichesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllNichesQuery = { __typename?: 'Query', allNiches?: Array<{ __typename?: 'Niche', id?: number | null, niche?: string | null, nicheAbbr?: string | null, disabled?: boolean | null } | null> | null };

export type PaginatedClientSelectedSiteListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedClientSelectedSiteListInput>;
}>;


export type PaginatedClientSelectedSiteListQuery = { __typename?: 'Query', paginatedClientSelectedSiteList?: { __typename?: 'paginatedClientSelectedSiteListOutput', totalPages?: number | null, totalRows?: number | null, siteUrls?: Array<{ __typename?: 'ClientSelectedSite', id?: number | null, orderID?: string | null, siteURL?: string | null } | null> | null } | null };

export type GetOrderByIdQueryVariables = Exact<{
  input?: InputMaybe<OrderIdInput>;
}>;


export type GetOrderByIdQuery = { __typename?: 'Query', getOrderByID?: { __typename?: 'mainOrders', id?: string | null, createdAt?: any | null, updatedAt?: any | null, orderStartDate?: any | null, orderDueDate?: any | null, ArticleCounts?: number | null, paymentStatus?: string | null, orderStatus?: string | null, clientSiteURL?: string | null, requiredDA?: number | null, requiredDR?: number | null, createdBy?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null } | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null, clientBaseURL?: Array<{ __typename?: 'ClientBaseURL', id: number, baseURL: string } | null> | null } | null, seoOrderManager?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null } | null, SeoOrders?: Array<{ __typename?: 'seoOrders', id?: string | null, dateOfAssignment?: any | null, instructionsSeoEmployee?: string | null, orderStatus?: string | null, updatedAt?: any | null, seoEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null } | null, LiveLinks?: Array<{ __typename?: 'liveLinks', id?: number | null, liveLinks?: string | null } | null> | null, CmsOrders?: Array<{ __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null } | null, Articles?: Array<{ __typename?: 'ArticleLinks', id?: number | null, articleLink?: string | null } | null> | null, cmsEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null } | null } | null> | null } | null> | null, package?: { __typename?: 'package', id?: number | null, packageName?: string | null, description?: string | null, price?: number | null, isDisabled?: boolean | null, SubPackage?: Array<{ __typename?: 'subPackage', id?: number | null, subPackageName?: string | null, packageDescription?: string | null, requiredDA?: string | null, price?: number | null } | null> | null } | null } | null };

export type GetSeoOrderByIdQueryVariables = Exact<{
  input?: InputMaybe<SeoOrderIdInput>;
}>;


export type GetSeoOrderByIdQuery = { __typename?: 'Query', getSeoOrderByID?: { __typename?: 'seoOrders', id?: string | null, dateOfAssignment?: any | null, instructionsSeoEmployee?: string | null, orderStatus?: string | null, updatedAt?: any | null, seoEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, CmsOrders?: Array<{ __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, cmsEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, Articles?: Array<{ __typename?: 'ArticleLinks', id?: number | null, articleLink?: string | null, articleWordCount?: number | null, niche?: string | null, keywords?: string | null, submissionDate?: any | null, publishingDate?: any | null } | null> | null } | null> | null, LiveLinks?: Array<{ __typename?: 'liveLinks', id?: number | null, seoOrderID?: string | null, liveLinks?: string | null } | null> | null, ClientSiteUrl?: Array<{ __typename?: 'ClientSiteURL', id?: number | null, clientSiteURL?: string | null, keyword?: string | null, requiredDA?: number | null, requiredDR?: number | null, updatedAt?: any | null } | null> | null, order?: { __typename?: 'mainOrders', orderDueDate?: any | null, orderStartDate?: any | null, orderStatus?: string | null, requiredDA?: number | null, requiredDR?: number | null, ArticleCounts?: number | null, SeoOrders?: Array<{ __typename?: 'seoOrders', instructionsSeoEmployee?: string | null } | null> | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null, clientBaseURL?: Array<{ __typename?: 'ClientBaseURL', id: number, clientID: number, baseURL: string } | null> | null } | null } | null } | null };

export type GetCmsOrderByIdQueryVariables = Exact<{
  input?: InputMaybe<CmsOrderIdInput>;
}>;


export type GetCmsOrderByIdQuery = { __typename?: 'Query', getCmsOrderByID?: { __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, cmsEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, seoOrder?: { __typename?: 'seoOrders', ClientSiteUrl?: Array<{ __typename?: 'ClientSiteURL', id?: number | null, clientSiteURL?: string | null, keyword?: string | null, requiredDA?: number | null, requiredDR?: number | null, updatedAt?: any | null } | null> | null, LiveLinks?: Array<{ __typename?: 'liveLinks', id?: number | null, seoOrderID?: string | null, liveLinks?: string | null } | null> | null, order?: { __typename?: 'mainOrders', id?: string | null, ArticleCounts?: number | null, requiredDA?: number | null, requiredDR?: number | null, orderDueDate?: any | null, orderStartDate?: any | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null, clientBaseURL?: Array<{ __typename?: 'ClientBaseURL', id: number, clientID: number, baseURL: string } | null> | null } | null } | null } | null, Articles?: Array<{ __typename?: 'ArticleLinks', id?: number | null, articleLink?: string | null, articleWordCount?: number | null, niche?: string | null, keywords?: string | null, submissionDate?: any | null, publishingDate?: any | null } | null> | null } | null };

export type PaginatedSubTaskListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedSubTaskListInput>;
}>;


export type PaginatedSubTaskListQuery = { __typename?: 'Query', paginatedSubTaskList?: { __typename?: 'paginatedSeoOrderListOutput', totalPages: number, totalRows: number, seoOrderList: Array<{ __typename?: 'seoOrders', id?: string | null, dateOfAssignment?: any | null, instructionsSeoEmployee?: string | null, orderStatus?: string | null, selectedSite?: string | null, actualDA?: number | null, updatedAt?: any | null, seoEmp?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, phone?: string | null, role?: Role | null } | null, ClientSiteUrl?: Array<{ __typename?: 'ClientSiteURL', id?: number | null, clientSiteURL?: string | null, keyword?: string | null, requiredDA?: number | null, requiredDR?: number | null, updatedAt?: any | null } | null> | null, CmsOrders?: Array<{ __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', firstName?: string | null, email?: string | null, id?: number | null, lastName?: string | null, phone?: string | null, role?: Role | null } | null, cmsEmp?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, role?: Role | null, phone?: string | null } | null, Articles?: Array<{ __typename?: 'ArticleLinks', id?: number | null, articleLink?: string | null } | null> | null } | null> | null, LiveLinks?: Array<{ __typename?: 'liveLinks', id?: number | null, liveLinks?: string | null } | null> | null } | null> } | null };

export type GetOrderGeneratedIdQueryVariables = Exact<{
  input?: InputMaybe<GetOrderGeneratedIdInput>;
}>;


export type GetOrderGeneratedIdQuery = { __typename?: 'Query', getOrderGeneratedID?: string | null };

export type GetAllOrderTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrderTypesQuery = { __typename?: 'Query', getAllOrderTypes?: Array<{ __typename?: 'orderType', id?: number | null, initials?: string | null, orderType?: string | null } | null> | null };

export type VerifyDomainQueryVariables = Exact<{
  input?: InputMaybe<VerifyDomainInput>;
}>;


export type VerifyDomainQuery = { __typename?: 'Query', verifyDomain?: { __typename?: 'verifyDomainOutput', verified: boolean, priceAsked?: number | null, finalPrice?: number | null, specialPrice?: number | null, domainID?: number | null, contactTypeID?: number | null, serviceType?: string | null, serviceTypeID?: number | null, siteDA?: number | null, siteDR?: number | null, siteTraffic?: number | null, contactedBy?: { __typename?: 'Employee', firstName?: string | null, email?: string | null, id?: number | null, lastName?: string | null } | null } | null };

export type GetAllServiceTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllServiceTypeQuery = { __typename?: 'Query', getAllServiceType?: Array<{ __typename?: 'ServiceTypes', id?: number | null, serviceType?: string | null } | null> | null };

export type MasterSheetQueryVariables = Exact<{
  input?: InputMaybe<GetDomainInput>;
}>;


export type MasterSheetQuery = { __typename?: 'Query', masterSheet?: { __typename?: 'MasterSheet', id: number, siteUrl: string, siteDA: number, siteDR: number, siteTraffic: number, domainDetails: Array<{ __typename?: 'DomainDetails', priceAsked: number, finalPrice: number, specialPrice: number, linkInsertionPrice?: number | null, dateOfContact: any, status: string, POC: string, updatedAt: any, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null }, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null }, serviceType: { __typename?: 'ServiceTypes', id?: number | null, serviceType?: string | null } } | null> } | null };

export type DomainQueryVariables = Exact<{
  input?: InputMaybe<DomainIdInput>;
}>;


export type DomainQuery = { __typename?: 'Query', domain?: { __typename?: 'MasterSheet', id: number, siteUrl: string, siteDA: number, siteDR: number, siteTraffic: number, createdAt: any, updatedAt: any, domainDetails: Array<{ __typename?: 'DomainDetails', priceAsked: number, finalPrice: number, specialPrice: number, linkInsertionPrice?: number | null, dateOfContact: any, status: string, POC: string, updatedAt: any, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null }, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null }, serviceType: { __typename?: 'ServiceTypes', id?: number | null, serviceType?: string | null } } | null>, siteContactDetails: Array<{ __typename?: 'SiteContactDetails', contactDetails?: string | null, updatedAt?: any | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null, updatedAt?: any | null } | null } | null>, DomainNiches: Array<{ __typename?: 'DomainNiche', updatedAt?: any | null, niche?: { __typename?: 'Niche', niche?: string | null, nicheAbbr?: string | null, disabled?: boolean | null } | null } | null>, DomainMasterSheetComments?: Array<{ __typename?: 'DomainMasterSheetComments', description?: string | null, id?: number | null, Employee?: { __typename?: 'Employee', firstName?: string | null, id?: number | null, lastName?: string | null, role?: Role | null } | null } | null> | null } | null };

export type GetAllSiteContactDetailsForDomainQueryVariables = Exact<{
  input?: InputMaybe<DomainIdInput>;
}>;


export type GetAllSiteContactDetailsForDomainQuery = { __typename?: 'Query', getAllSiteContactDetailsForDomain?: Array<string | null> | null };

export type GetAllNichesForDomainQueryVariables = Exact<{
  input?: InputMaybe<DomainIdInput>;
}>;


export type GetAllNichesForDomainQuery = { __typename?: 'Query', getAllNichesForDomain?: Array<string | null> | null };

export type PaginatedMasterSheetQueryVariables = Exact<{
  input?: InputMaybe<PaginateDmsInput>;
}>;


export type PaginatedMasterSheetQuery = { __typename?: 'Query', paginatedMasterSheet?: { __typename?: 'paginatedDMSOutput', totalPages?: number | null, totalRows?: number | null, dms?: Array<{ __typename?: 'MasterSheet', id: number, siteUrl: string, siteDA: number, siteDR: number, siteTraffic: number, ahrefTraffic: number, createdAt: any, updatedAt: any, DomainNiches: Array<{ __typename?: 'DomainNiche', niche?: { __typename?: 'Niche', id?: number | null, niche?: string | null, nicheAbbr?: string | null, disabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null } | null>, domainDetails: Array<{ __typename?: 'DomainDetails', priceAsked: number, finalPrice: number, specialPrice: number, dateOfContact: any, status: string, updatedAt: any, POC: string, linkInsertionPrice?: number | null, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, role?: Role | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null }, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null, updatedAt?: any | null }, serviceType: { __typename?: 'ServiceTypes', id?: number | null, serviceType?: string | null, updatedAt?: any | null } } | null>, siteContactDetails: Array<{ __typename?: 'SiteContactDetails', contactDetails?: string | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null> } | null> | null } | null };

export type GetAllNichesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNichesQuery = { __typename?: 'Query', getAllNiches?: Array<string | null> | null };

export type GetAllContactTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContactTypeQuery = { __typename?: 'Query', getAllContactType?: Array<{ __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null> | null };

export type GetEmployeeUsingTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeeUsingTokenQuery = { __typename?: 'Query', getEmployeeUsingToken?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null };

export type GetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees?: Array<{ __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, role?: Role | null, isActive?: boolean | null } | null> | null };

export type GetEmployeeIdQueryVariables = Exact<{
  getEmployeeIdId?: InputMaybe<Scalars['Int']>;
}>;


export type GetEmployeeIdQuery = { __typename?: 'Query', getEmployeeId?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null };

export type PaginatedEmployeeListQueryVariables = Exact<{
  input?: InputMaybe<PaginateEmpInput>;
}>;


export type PaginatedEmployeeListQuery = { __typename?: 'Query', paginatedEmployeeList?: { __typename?: 'paginatedEmpOutput', totalPages?: number | null, totalRows?: number | null, emplo?: Array<{ __typename?: 'Employee', createdAt?: any | null, email?: string | null, firstName?: string | null, id?: number | null, isActive?: boolean | null, lastName?: string | null, password?: string | null, phone?: string | null, role?: Role | null, updatedAt?: any | null } | null> | null } | null };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications?: Array<{ __typename?: 'Notification', id?: number | null, fromEmployeeID?: number | null, toEmployeeID?: number | null, title?: string | null, date?: any | null, description?: string | null, status?: boolean | null, redirectUrl?: string | null, fromEmployeeNotification?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, toEmployeeNotification?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null } | null> | null };

export type GetCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountsQuery = { __typename?: 'Query', getCounts?: { __typename?: 'getCounts', outreachedDMSCounts?: number | null, doneDMSCounts?: number | null, negotiatingDMSCounts?: number | null } | null };

export type GetNotificationByIdQueryVariables = Exact<{
  input?: InputMaybe<GetNotificationByIdInput>;
}>;


export type GetNotificationByIdQuery = { __typename?: 'Query', getNotificationById?: Array<{ __typename?: 'Notification', id?: number | null, fromEmployeeID?: number | null, toEmployeeID?: number | null, title?: string | null, date?: any | null, description?: string | null, status?: boolean | null, redirectUrl?: string | null, fromEmployeeNotification?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null, toEmployeeNotification?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null, role?: Role | null } | null } | null> | null };

export type PaginatedOrderListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedOrderListInput>;
}>;


export type PaginatedOrderListQuery = { __typename?: 'Query', paginatedOrderList?: { __typename?: 'paginatedOrderListOutput', totalPages: number, totalRows: number, orderList: Array<{ __typename?: 'mainOrders', id?: string | null, requiredDA?: number | null, requiredDR?: number | null, clientSiteURL?: string | null, orderStartDate?: any | null, orderDueDate?: any | null, ArticleCounts?: number | null, paymentStatus?: string | null, orderStatus?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null, clientBaseURL?: Array<{ __typename?: 'ClientBaseURL', id: number, clientID: number, baseURL: string } | null> | null } | null, seoOrderManager?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, SeoOrders?: Array<{ __typename?: 'seoOrders', id?: string | null, dateOfAssignment?: any | null, instructionsSeoEmployee?: string | null, orderStatus?: string | null, updatedAt?: any | null, seoEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, CmsOrders?: Array<{ __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, cmsEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null } | null> | null } | null> | null, package?: { __typename?: 'package', description?: string | null, id?: number | null, isDisabled?: boolean | null, packageName?: string | null, price?: number | null, SubPackage?: Array<{ __typename?: 'subPackage', id?: number | null, subPackageName?: string | null, packageDescription?: string | null, requiredDA?: string | null, price?: number | null } | null> | null } | null } | null> } | null };

export type PaginatedSeoOrderListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedSeoOrderListInput>;
}>;


export type PaginatedSeoOrderListQuery = { __typename?: 'Query', paginatedSeoOrderList?: { __typename?: 'paginatedSeoOrderListOutput', totalPages: number, totalRows: number, seoOrderList: Array<{ __typename?: 'seoOrders', id?: string | null, orderStatus?: string | null, ClientSiteUrl?: Array<{ __typename?: 'ClientSiteURL', clientSiteURL?: string | null, id?: number | null, keyword?: string | null, requiredDA?: number | null, requiredDR?: number | null } | null> | null, order?: { __typename?: 'mainOrders', ArticleCounts?: number | null, id?: string | null, orderDueDate?: any | null, orderStartDate?: any | null, requiredDA?: number | null, requiredDR?: number | null, orderStatus?: string | null, paymentStatus?: string | null, clientSiteURL?: string | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null } | null } | null, seoEmp?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, phone?: string | null, role?: Role | null } | null } | null> } | null };

export type PaginatedCmsOrderListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedCmsOrderListInput>;
}>;


export type PaginatedCmsOrderListQuery = { __typename?: 'Query', paginatedCmsOrderList?: { __typename?: 'paginatedCmsOrderListOutput', totalPages: number, totalRows: number, cmsOrderList: Array<{ __typename?: 'cmsOrders', id?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, phone?: string | null, role?: Role | null } | null, cmsEmp?: { __typename?: 'Employee', email?: string | null, firstName?: string | null, id?: number | null, lastName?: string | null, phone?: string | null, role?: Role | null } | null, seoOrder?: { __typename?: 'seoOrders', order?: { __typename?: 'mainOrders', id?: string | null, ArticleCounts?: number | null, orderStartDate?: any | null, orderDueDate?: any | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null } | null } | null, ClientSiteUrl?: Array<{ __typename?: 'ClientSiteURL', clientSiteURL?: string | null, keyword?: string | null, id?: number | null } | null> | null } | null } | null> } | null };

export type GetPaginatedPotentialSitesForClientQueryVariables = Exact<{
  input?: InputMaybe<GetPaginatedPotentialSitesForClientInput>;
}>;


export type GetPaginatedPotentialSitesForClientQuery = { __typename?: 'Query', getPaginatedPotentialSitesForClient?: { __typename?: 'paginatedDMSOutput', totalPages?: number | null, totalRows?: number | null, dms?: Array<{ __typename?: 'MasterSheet', id: number, siteUrl: string, siteDA: number, siteDR: number, siteTraffic: number, createdAt: any, updatedAt: any, DomainNiches: Array<{ __typename?: 'DomainNiche', niche?: { __typename?: 'Niche', id?: number | null, niche?: string | null, nicheAbbr?: string | null, disabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null } | null>, domainDetails: Array<{ __typename?: 'DomainDetails', priceAsked: number, finalPrice: number, specialPrice: number, dateOfContact: any, status: string, updatedAt: any, POC: string, linkInsertionPrice?: number | null, contactedBy: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, password?: string | null, role?: Role | null, isActive?: boolean | null, createdAt?: any | null, updatedAt?: any | null }, contactType: { __typename?: 'ContactType', id?: number | null, contactType?: string | null, updatedAt?: any | null }, serviceType: { __typename?: 'ServiceTypes', id?: number | null, serviceType?: string | null, updatedAt?: any | null } } | null>, siteContactDetails: Array<{ __typename?: 'SiteContactDetails', contactDetails?: string | null, contactType?: { __typename?: 'ContactType', id?: number | null, contactType?: string | null } | null } | null> } | null> | null } | null };

export type PaginatedCmsAdminOrderListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedCmsAdminOrderListInput>;
}>;


export type PaginatedCmsAdminOrderListQuery = { __typename?: 'Query', paginatedCmsAdminOrderList?: { __typename?: 'paginatedOrderListOutput', totalPages: number, totalRows: number, orderList: Array<{ __typename?: 'mainOrders', id?: string | null, clientSiteURL?: string | null, requiredDA?: number | null, requiredDR?: number | null, orderStartDate?: any | null, orderDueDate?: any | null, ArticleCounts?: number | null, orderStatus?: string | null, client?: { __typename?: 'Client', id?: number | null, name?: string | null, updatedAt?: any | null, clientBaseURL?: Array<{ __typename?: 'ClientBaseURL', id: number, clientID: number, baseURL: string } | null> | null } | null, seoOrderManager?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, SeoOrders?: Array<{ __typename?: 'seoOrders', id?: string | null, dateOfAssignment?: any | null, instructionsSeoEmployee?: string | null, orderStatus?: string | null, updatedAt?: any | null, seoEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, CmsOrders?: Array<{ __typename?: 'cmsOrders', id?: string | null, instructionCmsAdmin?: string | null, instructionCmsEmp?: string | null, dateOfAssignmentCmsEmployee?: any | null, dateOfAssignmentCmsAdmin?: any | null, updatedAt?: any | null, orderStatus?: string | null, cmsAdmin?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null, cmsEmp?: { __typename?: 'Employee', id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, role?: Role | null, phone?: string | null } | null } | null> | null } | null> | null } | null> } | null };

export type ViewPackageQueryVariables = Exact<{
  input?: InputMaybe<SearchFilter>;
}>;


export type ViewPackageQuery = { __typename?: 'Query', viewPackage?: Array<{ __typename?: 'package', id?: number | null, packageName?: string | null, description?: string | null, price?: number | null, isDisabled?: boolean | null, SubPackage?: Array<{ __typename?: 'subPackage', id?: number | null, packageDescription?: string | null, price?: number | null, requiredDA?: string | null, subPackageName?: string | null } | null> | null }> | null };

export type ViewSubPackageQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewSubPackageQuery = { __typename?: 'Query', viewSubPackage?: Array<{ __typename?: 'subPackage', id?: number | null, subPackageName?: string | null, packageDescription?: string | null, requiredDA?: string | null, price?: number | null }> | null };

export type GetPackageQueryVariables = Exact<{
  getPackageId: Scalars['Int'];
}>;


export type GetPackageQuery = { __typename?: 'Query', getPackage?: { __typename?: 'package', id?: number | null, packageName?: string | null, description?: string | null, price?: number | null, isDisabled?: boolean | null } | null };

export type GetSubPackageQueryVariables = Exact<{
  getSubPackageId: Scalars['Int'];
}>;


export type GetSubPackageQuery = { __typename?: 'Query', getSubPackage?: { __typename?: 'subPackage', id?: number | null, subPackageName?: string | null, packageDescription?: string | null, requiredDA?: string | null, price?: number | null } | null };

export type PaginatedPackageListQueryVariables = Exact<{
  input?: InputMaybe<PaginatedPackageInput>;
}>;


export type PaginatedPackageListQuery = { __typename?: 'Query', paginatedPackageList?: { __typename?: 'paginatedPackageOutput', totalPages?: number | null, totalRows?: number | null, pack?: Array<{ __typename?: 'package', id?: number | null, description?: string | null, packageName?: string | null, price?: number | null, isDisabled?: boolean | null } | null> | null } | null };

export type GetAllPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPackagesQuery = { __typename?: 'Query', getAllPackages?: Array<{ __typename?: 'package', id?: number | null, packageName?: string | null, description?: string | null, price?: number | null, isDisabled?: boolean | null, SubPackage?: Array<{ __typename?: 'subPackage', id?: number | null, subPackageName?: string | null, packageDescription?: string | null, requiredDA?: string | null, price?: number | null } | null> | null } | null> | null };


export const AccountTransferDocument = gql`
    mutation AccountTransfer($input: AccountTransferInput) {
  accountTransfer(input: $input) {
    success
    message
    token
  }
}
    `;
export type AccountTransferMutationFn = Apollo.MutationFunction<AccountTransferMutation, AccountTransferMutationVariables>;

/**
 * __useAccountTransferMutation__
 *
 * To run a mutation, you first call `useAccountTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTransferMutation, { data, loading, error }] = useAccountTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountTransferMutation(baseOptions?: Apollo.MutationHookOptions<AccountTransferMutation, AccountTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountTransferMutation, AccountTransferMutationVariables>(AccountTransferDocument, options);
      }
export type AccountTransferMutationHookResult = ReturnType<typeof useAccountTransferMutation>;
export type AccountTransferMutationResult = Apollo.MutationResult<AccountTransferMutation>;
export type AccountTransferMutationOptions = Apollo.BaseMutationOptions<AccountTransferMutation, AccountTransferMutationVariables>;
export const AddNewCommentDocument = gql`
    mutation AddNewComment($input: newCommentInput!) {
  addNewComment(input: $input) {
    success
    message
    token
  }
}
    `;
export type AddNewCommentMutationFn = Apollo.MutationFunction<AddNewCommentMutation, AddNewCommentMutationVariables>;

/**
 * __useAddNewCommentMutation__
 *
 * To run a mutation, you first call `useAddNewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewCommentMutation, { data, loading, error }] = useAddNewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddNewCommentMutation, AddNewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewCommentMutation, AddNewCommentMutationVariables>(AddNewCommentDocument, options);
      }
export type AddNewCommentMutationHookResult = ReturnType<typeof useAddNewCommentMutation>;
export type AddNewCommentMutationResult = Apollo.MutationResult<AddNewCommentMutation>;
export type AddNewCommentMutationOptions = Apollo.BaseMutationOptions<AddNewCommentMutation, AddNewCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: updateCommentInput!) {
  updateComment(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CreateContentOrderServiceTypeDocument = gql`
    mutation CreateContentOrderServiceType($input: createContentOrderServiceTypeInput) {
  createContentOrderServiceType(input: $input) {
    success
    message
    token
  }
}
    `;
export type CreateContentOrderServiceTypeMutationFn = Apollo.MutationFunction<CreateContentOrderServiceTypeMutation, CreateContentOrderServiceTypeMutationVariables>;

/**
 * __useCreateContentOrderServiceTypeMutation__
 *
 * To run a mutation, you first call `useCreateContentOrderServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentOrderServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentOrderServiceTypeMutation, { data, loading, error }] = useCreateContentOrderServiceTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentOrderServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentOrderServiceTypeMutation, CreateContentOrderServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentOrderServiceTypeMutation, CreateContentOrderServiceTypeMutationVariables>(CreateContentOrderServiceTypeDocument, options);
      }
export type CreateContentOrderServiceTypeMutationHookResult = ReturnType<typeof useCreateContentOrderServiceTypeMutation>;
export type CreateContentOrderServiceTypeMutationResult = Apollo.MutationResult<CreateContentOrderServiceTypeMutation>;
export type CreateContentOrderServiceTypeMutationOptions = Apollo.BaseMutationOptions<CreateContentOrderServiceTypeMutation, CreateContentOrderServiceTypeMutationVariables>;
export const CreateContentOrderDocument = gql`
    mutation CreateContentOrder($input: createContentOrderInput) {
  createContentOrder(input: $input) {
    success
    message
    token
  }
}
    `;
export type CreateContentOrderMutationFn = Apollo.MutationFunction<CreateContentOrderMutation, CreateContentOrderMutationVariables>;

/**
 * __useCreateContentOrderMutation__
 *
 * To run a mutation, you first call `useCreateContentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentOrderMutation, { data, loading, error }] = useCreateContentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentOrderMutation, CreateContentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentOrderMutation, CreateContentOrderMutationVariables>(CreateContentOrderDocument, options);
      }
export type CreateContentOrderMutationHookResult = ReturnType<typeof useCreateContentOrderMutation>;
export type CreateContentOrderMutationResult = Apollo.MutationResult<CreateContentOrderMutation>;
export type CreateContentOrderMutationOptions = Apollo.BaseMutationOptions<CreateContentOrderMutation, CreateContentOrderMutationVariables>;
export const UpdateContentOrderServiceTypeStatusDocument = gql`
    mutation UpdateContentOrderServiceTypeStatus($input: updateContentOrderServiceTypeStatusInput) {
  updateContentOrderServiceTypeStatus(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateContentOrderServiceTypeStatusMutationFn = Apollo.MutationFunction<UpdateContentOrderServiceTypeStatusMutation, UpdateContentOrderServiceTypeStatusMutationVariables>;

/**
 * __useUpdateContentOrderServiceTypeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContentOrderServiceTypeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentOrderServiceTypeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentOrderServiceTypeStatusMutation, { data, loading, error }] = useUpdateContentOrderServiceTypeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentOrderServiceTypeStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentOrderServiceTypeStatusMutation, UpdateContentOrderServiceTypeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentOrderServiceTypeStatusMutation, UpdateContentOrderServiceTypeStatusMutationVariables>(UpdateContentOrderServiceTypeStatusDocument, options);
      }
export type UpdateContentOrderServiceTypeStatusMutationHookResult = ReturnType<typeof useUpdateContentOrderServiceTypeStatusMutation>;
export type UpdateContentOrderServiceTypeStatusMutationResult = Apollo.MutationResult<UpdateContentOrderServiceTypeStatusMutation>;
export type UpdateContentOrderServiceTypeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateContentOrderServiceTypeStatusMutation, UpdateContentOrderServiceTypeStatusMutationVariables>;
export const AssignCmsAdminDocument = gql`
    mutation AssignCMSAdmin($input: contentOrderAssignEmployeeIdInput) {
  assignCMSAdmin(input: $input) {
    success
    message
    token
  }
}
    `;
export type AssignCmsAdminMutationFn = Apollo.MutationFunction<AssignCmsAdminMutation, AssignCmsAdminMutationVariables>;

/**
 * __useAssignCmsAdminMutation__
 *
 * To run a mutation, you first call `useAssignCmsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCmsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCmsAdminMutation, { data, loading, error }] = useAssignCmsAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCmsAdminMutation(baseOptions?: Apollo.MutationHookOptions<AssignCmsAdminMutation, AssignCmsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCmsAdminMutation, AssignCmsAdminMutationVariables>(AssignCmsAdminDocument, options);
      }
export type AssignCmsAdminMutationHookResult = ReturnType<typeof useAssignCmsAdminMutation>;
export type AssignCmsAdminMutationResult = Apollo.MutationResult<AssignCmsAdminMutation>;
export type AssignCmsAdminMutationOptions = Apollo.BaseMutationOptions<AssignCmsAdminMutation, AssignCmsAdminMutationVariables>;
export const AssignCmsEmployeeDocument = gql`
    mutation AssignCMSEmployee($input: contentOrderAssignEmployeeIdInput) {
  assignCMSEmployee(input: $input) {
    success
    message
    token
  }
}
    `;
export type AssignCmsEmployeeMutationFn = Apollo.MutationFunction<AssignCmsEmployeeMutation, AssignCmsEmployeeMutationVariables>;

/**
 * __useAssignCmsEmployeeMutation__
 *
 * To run a mutation, you first call `useAssignCmsEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCmsEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCmsEmployeeMutation, { data, loading, error }] = useAssignCmsEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCmsEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<AssignCmsEmployeeMutation, AssignCmsEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCmsEmployeeMutation, AssignCmsEmployeeMutationVariables>(AssignCmsEmployeeDocument, options);
      }
export type AssignCmsEmployeeMutationHookResult = ReturnType<typeof useAssignCmsEmployeeMutation>;
export type AssignCmsEmployeeMutationResult = Apollo.MutationResult<AssignCmsEmployeeMutation>;
export type AssignCmsEmployeeMutationOptions = Apollo.BaseMutationOptions<AssignCmsEmployeeMutation, AssignCmsEmployeeMutationVariables>;
export const ContentOrderArticleLinkDocument = gql`
    mutation ContentOrderArticleLink($input: contentOrderArticleLinkInput) {
  contentOrderArticleLink(input: $input) {
    success
    message
    token
  }
}
    `;
export type ContentOrderArticleLinkMutationFn = Apollo.MutationFunction<ContentOrderArticleLinkMutation, ContentOrderArticleLinkMutationVariables>;

/**
 * __useContentOrderArticleLinkMutation__
 *
 * To run a mutation, you first call `useContentOrderArticleLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentOrderArticleLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentOrderArticleLinkMutation, { data, loading, error }] = useContentOrderArticleLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContentOrderArticleLinkMutation(baseOptions?: Apollo.MutationHookOptions<ContentOrderArticleLinkMutation, ContentOrderArticleLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentOrderArticleLinkMutation, ContentOrderArticleLinkMutationVariables>(ContentOrderArticleLinkDocument, options);
      }
export type ContentOrderArticleLinkMutationHookResult = ReturnType<typeof useContentOrderArticleLinkMutation>;
export type ContentOrderArticleLinkMutationResult = Apollo.MutationResult<ContentOrderArticleLinkMutation>;
export type ContentOrderArticleLinkMutationOptions = Apollo.BaseMutationOptions<ContentOrderArticleLinkMutation, ContentOrderArticleLinkMutationVariables>;
export const UpdateContentOrderDocument = gql`
    mutation UpdateContentOrder($input: updateContentOrderInput) {
  updateContentOrder(input: $input) {
    success
    message
  }
}
    `;
export type UpdateContentOrderMutationFn = Apollo.MutationFunction<UpdateContentOrderMutation, UpdateContentOrderMutationVariables>;

/**
 * __useUpdateContentOrderMutation__
 *
 * To run a mutation, you first call `useUpdateContentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentOrderMutation, { data, loading, error }] = useUpdateContentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentOrderMutation, UpdateContentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentOrderMutation, UpdateContentOrderMutationVariables>(UpdateContentOrderDocument, options);
      }
export type UpdateContentOrderMutationHookResult = ReturnType<typeof useUpdateContentOrderMutation>;
export type UpdateContentOrderMutationResult = Apollo.MutationResult<UpdateContentOrderMutation>;
export type UpdateContentOrderMutationOptions = Apollo.BaseMutationOptions<UpdateContentOrderMutation, UpdateContentOrderMutationVariables>;
export const UpdateContentOrderStatusDocument = gql`
    mutation UpdateContentOrderStatus($input: updateContentOrderStatusInput) {
  updateContentOrderStatus(input: $input) {
    success
    message
  }
}
    `;
export type UpdateContentOrderStatusMutationFn = Apollo.MutationFunction<UpdateContentOrderStatusMutation, UpdateContentOrderStatusMutationVariables>;

/**
 * __useUpdateContentOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContentOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentOrderStatusMutation, { data, loading, error }] = useUpdateContentOrderStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentOrderStatusMutation, UpdateContentOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentOrderStatusMutation, UpdateContentOrderStatusMutationVariables>(UpdateContentOrderStatusDocument, options);
      }
export type UpdateContentOrderStatusMutationHookResult = ReturnType<typeof useUpdateContentOrderStatusMutation>;
export type UpdateContentOrderStatusMutationResult = Apollo.MutationResult<UpdateContentOrderStatusMutation>;
export type UpdateContentOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateContentOrderStatusMutation, UpdateContentOrderStatusMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: OrderInput!) {
  createOrder(input: $input) {
    success
    message
    token
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreateNicheDocument = gql`
    mutation CreateNiche($input: createNicheInput) {
  createNiche(input: $input) {
    success
    message
    token
  }
}
    `;
export type CreateNicheMutationFn = Apollo.MutationFunction<CreateNicheMutation, CreateNicheMutationVariables>;

/**
 * __useCreateNicheMutation__
 *
 * To run a mutation, you first call `useCreateNicheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNicheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNicheMutation, { data, loading, error }] = useCreateNicheMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNicheMutation(baseOptions?: Apollo.MutationHookOptions<CreateNicheMutation, CreateNicheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNicheMutation, CreateNicheMutationVariables>(CreateNicheDocument, options);
      }
export type CreateNicheMutationHookResult = ReturnType<typeof useCreateNicheMutation>;
export type CreateNicheMutationResult = Apollo.MutationResult<CreateNicheMutation>;
export type CreateNicheMutationOptions = Apollo.BaseMutationOptions<CreateNicheMutation, CreateNicheMutationVariables>;
export const UpdateNicheStatusDocument = gql`
    mutation UpdateNicheStatus($input: updateNicheStatusInput) {
  updateNicheStatus(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateNicheStatusMutationFn = Apollo.MutationFunction<UpdateNicheStatusMutation, UpdateNicheStatusMutationVariables>;

/**
 * __useUpdateNicheStatusMutation__
 *
 * To run a mutation, you first call `useUpdateNicheStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNicheStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNicheStatusMutation, { data, loading, error }] = useUpdateNicheStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNicheStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNicheStatusMutation, UpdateNicheStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNicheStatusMutation, UpdateNicheStatusMutationVariables>(UpdateNicheStatusDocument, options);
      }
export type UpdateNicheStatusMutationHookResult = ReturnType<typeof useUpdateNicheStatusMutation>;
export type UpdateNicheStatusMutationResult = Apollo.MutationResult<UpdateNicheStatusMutation>;
export type UpdateNicheStatusMutationOptions = Apollo.BaseMutationOptions<UpdateNicheStatusMutation, UpdateNicheStatusMutationVariables>;
export const UpdateSeoOrdersDocument = gql`
    mutation UpdateSeoOrders($input: updateSeoOrder!) {
  updateSeoOrders(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateSeoOrdersMutationFn = Apollo.MutationFunction<UpdateSeoOrdersMutation, UpdateSeoOrdersMutationVariables>;

/**
 * __useUpdateSeoOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateSeoOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeoOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeoOrdersMutation, { data, loading, error }] = useUpdateSeoOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeoOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeoOrdersMutation, UpdateSeoOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeoOrdersMutation, UpdateSeoOrdersMutationVariables>(UpdateSeoOrdersDocument, options);
      }
export type UpdateSeoOrdersMutationHookResult = ReturnType<typeof useUpdateSeoOrdersMutation>;
export type UpdateSeoOrdersMutationResult = Apollo.MutationResult<UpdateSeoOrdersMutation>;
export type UpdateSeoOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateSeoOrdersMutation, UpdateSeoOrdersMutationVariables>;
export const UpdateMainOrdersDocument = gql`
    mutation UpdateMainOrders($input: updateMainOrder!) {
  updateMainOrders(input: $input) {
    success
    message
  }
}
    `;
export type UpdateMainOrdersMutationFn = Apollo.MutationFunction<UpdateMainOrdersMutation, UpdateMainOrdersMutationVariables>;

/**
 * __useUpdateMainOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateMainOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainOrdersMutation, { data, loading, error }] = useUpdateMainOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMainOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMainOrdersMutation, UpdateMainOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMainOrdersMutation, UpdateMainOrdersMutationVariables>(UpdateMainOrdersDocument, options);
      }
export type UpdateMainOrdersMutationHookResult = ReturnType<typeof useUpdateMainOrdersMutation>;
export type UpdateMainOrdersMutationResult = Apollo.MutationResult<UpdateMainOrdersMutation>;
export type UpdateMainOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateMainOrdersMutation, UpdateMainOrdersMutationVariables>;
export const ViewOrderUpdateDocument = gql`
    mutation ViewOrderUpdate($input: viewOrderUpdateInput) {
  viewOrderUpdate(input: $input) {
    success
    message
    token
  }
}
    `;
export type ViewOrderUpdateMutationFn = Apollo.MutationFunction<ViewOrderUpdateMutation, ViewOrderUpdateMutationVariables>;

/**
 * __useViewOrderUpdateMutation__
 *
 * To run a mutation, you first call `useViewOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewOrderUpdateMutation, { data, loading, error }] = useViewOrderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViewOrderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ViewOrderUpdateMutation, ViewOrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewOrderUpdateMutation, ViewOrderUpdateMutationVariables>(ViewOrderUpdateDocument, options);
      }
export type ViewOrderUpdateMutationHookResult = ReturnType<typeof useViewOrderUpdateMutation>;
export type ViewOrderUpdateMutationResult = Apollo.MutationResult<ViewOrderUpdateMutation>;
export type ViewOrderUpdateMutationOptions = Apollo.BaseMutationOptions<ViewOrderUpdateMutation, ViewOrderUpdateMutationVariables>;
export const ViewOrderUpdateCmsDocument = gql`
    mutation ViewOrderUpdateCms($input: viewOrderUpdateInputCms) {
  viewOrderUpdateCms(input: $input) {
    success
    message
    token
  }
}
    `;
export type ViewOrderUpdateCmsMutationFn = Apollo.MutationFunction<ViewOrderUpdateCmsMutation, ViewOrderUpdateCmsMutationVariables>;

/**
 * __useViewOrderUpdateCmsMutation__
 *
 * To run a mutation, you first call `useViewOrderUpdateCmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewOrderUpdateCmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewOrderUpdateCmsMutation, { data, loading, error }] = useViewOrderUpdateCmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViewOrderUpdateCmsMutation(baseOptions?: Apollo.MutationHookOptions<ViewOrderUpdateCmsMutation, ViewOrderUpdateCmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewOrderUpdateCmsMutation, ViewOrderUpdateCmsMutationVariables>(ViewOrderUpdateCmsDocument, options);
      }
export type ViewOrderUpdateCmsMutationHookResult = ReturnType<typeof useViewOrderUpdateCmsMutation>;
export type ViewOrderUpdateCmsMutationResult = Apollo.MutationResult<ViewOrderUpdateCmsMutation>;
export type ViewOrderUpdateCmsMutationOptions = Apollo.BaseMutationOptions<ViewOrderUpdateCmsMutation, ViewOrderUpdateCmsMutationVariables>;
export const UpdateSeoOrderManagerDocument = gql`
    mutation UpdateSeoOrderManager($input: updateSeoOrderManagerInput) {
  updateSeoOrderManager(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateSeoOrderManagerMutationFn = Apollo.MutationFunction<UpdateSeoOrderManagerMutation, UpdateSeoOrderManagerMutationVariables>;

/**
 * __useUpdateSeoOrderManagerMutation__
 *
 * To run a mutation, you first call `useUpdateSeoOrderManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeoOrderManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeoOrderManagerMutation, { data, loading, error }] = useUpdateSeoOrderManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeoOrderManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeoOrderManagerMutation, UpdateSeoOrderManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeoOrderManagerMutation, UpdateSeoOrderManagerMutationVariables>(UpdateSeoOrderManagerDocument, options);
      }
export type UpdateSeoOrderManagerMutationHookResult = ReturnType<typeof useUpdateSeoOrderManagerMutation>;
export type UpdateSeoOrderManagerMutationResult = Apollo.MutationResult<UpdateSeoOrderManagerMutation>;
export type UpdateSeoOrderManagerMutationOptions = Apollo.BaseMutationOptions<UpdateSeoOrderManagerMutation, UpdateSeoOrderManagerMutationVariables>;
export const UpdateMainOrderStatusDocument = gql`
    mutation UpdateMainOrderStatus($input: updateMainOrderStatusInput) {
  updateMainOrderStatus(input: $input) {
    success
    message
  }
}
    `;
export type UpdateMainOrderStatusMutationFn = Apollo.MutationFunction<UpdateMainOrderStatusMutation, UpdateMainOrderStatusMutationVariables>;

/**
 * __useUpdateMainOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMainOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainOrderStatusMutation, { data, loading, error }] = useUpdateMainOrderStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMainOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMainOrderStatusMutation, UpdateMainOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMainOrderStatusMutation, UpdateMainOrderStatusMutationVariables>(UpdateMainOrderStatusDocument, options);
      }
export type UpdateMainOrderStatusMutationHookResult = ReturnType<typeof useUpdateMainOrderStatusMutation>;
export type UpdateMainOrderStatusMutationResult = Apollo.MutationResult<UpdateMainOrderStatusMutation>;
export type UpdateMainOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateMainOrderStatusMutation, UpdateMainOrderStatusMutationVariables>;
export const CreateDomainTransferRequestDocument = gql`
    mutation CreateDomainTransferRequest($input: createDomainTransferRequestInput) {
  createDomainTransferRequest(input: $input) {
    success
    message
  }
}
    `;
export type CreateDomainTransferRequestMutationFn = Apollo.MutationFunction<CreateDomainTransferRequestMutation, CreateDomainTransferRequestMutationVariables>;

/**
 * __useCreateDomainTransferRequestMutation__
 *
 * To run a mutation, you first call `useCreateDomainTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDomainTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDomainTransferRequestMutation, { data, loading, error }] = useCreateDomainTransferRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDomainTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDomainTransferRequestMutation, CreateDomainTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDomainTransferRequestMutation, CreateDomainTransferRequestMutationVariables>(CreateDomainTransferRequestDocument, options);
      }
export type CreateDomainTransferRequestMutationHookResult = ReturnType<typeof useCreateDomainTransferRequestMutation>;
export type CreateDomainTransferRequestMutationResult = Apollo.MutationResult<CreateDomainTransferRequestMutation>;
export type CreateDomainTransferRequestMutationOptions = Apollo.BaseMutationOptions<CreateDomainTransferRequestMutation, CreateDomainTransferRequestMutationVariables>;
export const AcceptDomainTransferRequestDocument = gql`
    mutation AcceptDomainTransferRequest($input: DomainTransferRequestStatusInput) {
  acceptDomainTransferRequest(input: $input) {
    success
    message
    token
  }
}
    `;
export type AcceptDomainTransferRequestMutationFn = Apollo.MutationFunction<AcceptDomainTransferRequestMutation, AcceptDomainTransferRequestMutationVariables>;

/**
 * __useAcceptDomainTransferRequestMutation__
 *
 * To run a mutation, you first call `useAcceptDomainTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDomainTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDomainTransferRequestMutation, { data, loading, error }] = useAcceptDomainTransferRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptDomainTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptDomainTransferRequestMutation, AcceptDomainTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptDomainTransferRequestMutation, AcceptDomainTransferRequestMutationVariables>(AcceptDomainTransferRequestDocument, options);
      }
export type AcceptDomainTransferRequestMutationHookResult = ReturnType<typeof useAcceptDomainTransferRequestMutation>;
export type AcceptDomainTransferRequestMutationResult = Apollo.MutationResult<AcceptDomainTransferRequestMutation>;
export type AcceptDomainTransferRequestMutationOptions = Apollo.BaseMutationOptions<AcceptDomainTransferRequestMutation, AcceptDomainTransferRequestMutationVariables>;
export const RejectDomainTransferRequestDocument = gql`
    mutation RejectDomainTransferRequest($input: DomainTransferRequestStatusInput) {
  rejectDomainTransferRequest(input: $input) {
    success
    message
    token
  }
}
    `;
export type RejectDomainTransferRequestMutationFn = Apollo.MutationFunction<RejectDomainTransferRequestMutation, RejectDomainTransferRequestMutationVariables>;

/**
 * __useRejectDomainTransferRequestMutation__
 *
 * To run a mutation, you first call `useRejectDomainTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectDomainTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectDomainTransferRequestMutation, { data, loading, error }] = useRejectDomainTransferRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectDomainTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectDomainTransferRequestMutation, RejectDomainTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectDomainTransferRequestMutation, RejectDomainTransferRequestMutationVariables>(RejectDomainTransferRequestDocument, options);
      }
export type RejectDomainTransferRequestMutationHookResult = ReturnType<typeof useRejectDomainTransferRequestMutation>;
export type RejectDomainTransferRequestMutationResult = Apollo.MutationResult<RejectDomainTransferRequestMutation>;
export type RejectDomainTransferRequestMutationOptions = Apollo.BaseMutationOptions<RejectDomainTransferRequestMutation, RejectDomainTransferRequestMutationVariables>;
export const UpdateDomainDetailStatusDocument = gql`
    mutation UpdateDomainDetailStatus($input: updateDomainDetailStatusInput) {
  updateDomainDetailStatus(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateDomainDetailStatusMutationFn = Apollo.MutationFunction<UpdateDomainDetailStatusMutation, UpdateDomainDetailStatusMutationVariables>;

/**
 * __useUpdateDomainDetailStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDomainDetailStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainDetailStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainDetailStatusMutation, { data, loading, error }] = useUpdateDomainDetailStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDomainDetailStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainDetailStatusMutation, UpdateDomainDetailStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainDetailStatusMutation, UpdateDomainDetailStatusMutationVariables>(UpdateDomainDetailStatusDocument, options);
      }
export type UpdateDomainDetailStatusMutationHookResult = ReturnType<typeof useUpdateDomainDetailStatusMutation>;
export type UpdateDomainDetailStatusMutationResult = Apollo.MutationResult<UpdateDomainDetailStatusMutation>;
export type UpdateDomainDetailStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDomainDetailStatusMutation, UpdateDomainDetailStatusMutationVariables>;
export const UpdateDomainDocument = gql`
    mutation UpdateDomain($input: updateDomainInput) {
  updateDomain(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateDomainMutationFn = Apollo.MutationFunction<UpdateDomainMutation, UpdateDomainMutationVariables>;

/**
 * __useUpdateDomainMutation__
 *
 * To run a mutation, you first call `useUpdateDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainMutation, { data, loading, error }] = useUpdateDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainMutation, UpdateDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainMutation, UpdateDomainMutationVariables>(UpdateDomainDocument, options);
      }
export type UpdateDomainMutationHookResult = ReturnType<typeof useUpdateDomainMutation>;
export type UpdateDomainMutationResult = Apollo.MutationResult<UpdateDomainMutation>;
export type UpdateDomainMutationOptions = Apollo.BaseMutationOptions<UpdateDomainMutation, UpdateDomainMutationVariables>;
export const CreateMasterSheetDocument = gql`
    mutation CreateMasterSheet($input: createMasterSheetInput) {
  createMasterSheet(input: $input) {
    success
    message
    token
  }
}
    `;
export type CreateMasterSheetMutationFn = Apollo.MutationFunction<CreateMasterSheetMutation, CreateMasterSheetMutationVariables>;

/**
 * __useCreateMasterSheetMutation__
 *
 * To run a mutation, you first call `useCreateMasterSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterSheetMutation, { data, loading, error }] = useCreateMasterSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterSheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterSheetMutation, CreateMasterSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterSheetMutation, CreateMasterSheetMutationVariables>(CreateMasterSheetDocument, options);
      }
export type CreateMasterSheetMutationHookResult = ReturnType<typeof useCreateMasterSheetMutation>;
export type CreateMasterSheetMutationResult = Apollo.MutationResult<CreateMasterSheetMutation>;
export type CreateMasterSheetMutationOptions = Apollo.BaseMutationOptions<CreateMasterSheetMutation, CreateMasterSheetMutationVariables>;
export const AddEmployeeDocument = gql`
    mutation addEmployee($input: addEmployee) {
  addEmployee(input: $input) {
    success
    message
    token
  }
}
    `;
export type AddEmployeeMutationFn = Apollo.MutationFunction<AddEmployeeMutation, AddEmployeeMutationVariables>;

/**
 * __useAddEmployeeMutation__
 *
 * To run a mutation, you first call `useAddEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeMutation, { data, loading, error }] = useAddEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeMutation, AddEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeMutation, AddEmployeeMutationVariables>(AddEmployeeDocument, options);
      }
export type AddEmployeeMutationHookResult = ReturnType<typeof useAddEmployeeMutation>;
export type AddEmployeeMutationResult = Apollo.MutationResult<AddEmployeeMutation>;
export type AddEmployeeMutationOptions = Apollo.BaseMutationOptions<AddEmployeeMutation, AddEmployeeMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: updatePassword) {
  updatePassword(input: $input) {
    message
    success
    token
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: updateEmployee) {
  updateEmployee(input: $input) {
    message
    success
    token
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DisableEmployeeDocument = gql`
    mutation DisableEmployee($input: disableEmployeeInput) {
  disableEmployee(input: $input) {
    success
    message
  }
}
    `;
export type DisableEmployeeMutationFn = Apollo.MutationFunction<DisableEmployeeMutation, DisableEmployeeMutationVariables>;

/**
 * __useDisableEmployeeMutation__
 *
 * To run a mutation, you first call `useDisableEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableEmployeeMutation, { data, loading, error }] = useDisableEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DisableEmployeeMutation, DisableEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableEmployeeMutation, DisableEmployeeMutationVariables>(DisableEmployeeDocument, options);
      }
export type DisableEmployeeMutationHookResult = ReturnType<typeof useDisableEmployeeMutation>;
export type DisableEmployeeMutationResult = Apollo.MutationResult<DisableEmployeeMutation>;
export type DisableEmployeeMutationOptions = Apollo.BaseMutationOptions<DisableEmployeeMutation, DisableEmployeeMutationVariables>;
export const EnableEmployeeDocument = gql`
    mutation EnableEmployee($input: enableEmployeeInput) {
  enableEmployee(input: $input) {
    message
    success
  }
}
    `;
export type EnableEmployeeMutationFn = Apollo.MutationFunction<EnableEmployeeMutation, EnableEmployeeMutationVariables>;

/**
 * __useEnableEmployeeMutation__
 *
 * To run a mutation, you first call `useEnableEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableEmployeeMutation, { data, loading, error }] = useEnableEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<EnableEmployeeMutation, EnableEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableEmployeeMutation, EnableEmployeeMutationVariables>(EnableEmployeeDocument, options);
      }
export type EnableEmployeeMutationHookResult = ReturnType<typeof useEnableEmployeeMutation>;
export type EnableEmployeeMutationResult = Apollo.MutationResult<EnableEmployeeMutation>;
export type EnableEmployeeMutationOptions = Apollo.BaseMutationOptions<EnableEmployeeMutation, EnableEmployeeMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($input: updateNotificationInput) {
  updateNotification(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const LoginEmployeeDocument = gql`
    mutation LoginEmployee($input: loginEmployeeInput) {
  loginEmployee(input: $input) {
    success
    message
    token
  }
}
    `;
export type LoginEmployeeMutationFn = Apollo.MutationFunction<LoginEmployeeMutation, LoginEmployeeMutationVariables>;

/**
 * __useLoginEmployeeMutation__
 *
 * To run a mutation, you first call `useLoginEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEmployeeMutation, { data, loading, error }] = useLoginEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginEmployeeMutation, LoginEmployeeMutationVariables>(LoginEmployeeDocument, options);
      }
export type LoginEmployeeMutationHookResult = ReturnType<typeof useLoginEmployeeMutation>;
export type LoginEmployeeMutationResult = Apollo.MutationResult<LoginEmployeeMutation>;
export type LoginEmployeeMutationOptions = Apollo.BaseMutationOptions<LoginEmployeeMutation, LoginEmployeeMutationVariables>;
export const AddTodoDocument = gql`
    mutation AddTodo($input: toDoInput) {
  addTodo(input: $input) {
    success
    message
    token
  }
}
    `;
export type AddTodoMutationFn = Apollo.MutationFunction<AddTodoMutation, AddTodoMutationVariables>;

/**
 * __useAddTodoMutation__
 *
 * To run a mutation, you first call `useAddTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTodoMutation, { data, loading, error }] = useAddTodoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTodoMutation(baseOptions?: Apollo.MutationHookOptions<AddTodoMutation, AddTodoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTodoMutation, AddTodoMutationVariables>(AddTodoDocument, options);
      }
export type AddTodoMutationHookResult = ReturnType<typeof useAddTodoMutation>;
export type AddTodoMutationResult = Apollo.MutationResult<AddTodoMutation>;
export type AddTodoMutationOptions = Apollo.BaseMutationOptions<AddTodoMutation, AddTodoMutationVariables>;
export const UpdateTodoDocument = gql`
    mutation UpdateTodo($input: updateTodoInput) {
  updateTodo(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateTodoMutationFn = Apollo.MutationFunction<UpdateTodoMutation, UpdateTodoMutationVariables>;

/**
 * __useUpdateTodoMutation__
 *
 * To run a mutation, you first call `useUpdateTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTodoMutation, { data, loading, error }] = useUpdateTodoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTodoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTodoMutation, UpdateTodoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTodoMutation, UpdateTodoMutationVariables>(UpdateTodoDocument, options);
      }
export type UpdateTodoMutationHookResult = ReturnType<typeof useUpdateTodoMutation>;
export type UpdateTodoMutationResult = Apollo.MutationResult<UpdateTodoMutation>;
export type UpdateTodoMutationOptions = Apollo.BaseMutationOptions<UpdateTodoMutation, UpdateTodoMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: forgotPasswordInput) {
  forgotPassword(input: $input) {
    success
    message
    token
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const AddNewPackageDocument = gql`
    mutation AddNewPackage($input: NewPackage!) {
  addNewPackage(input: $input) {
    success
    message
    token
  }
}
    `;
export type AddNewPackageMutationFn = Apollo.MutationFunction<AddNewPackageMutation, AddNewPackageMutationVariables>;

/**
 * __useAddNewPackageMutation__
 *
 * To run a mutation, you first call `useAddNewPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewPackageMutation, { data, loading, error }] = useAddNewPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddNewPackageMutation, AddNewPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewPackageMutation, AddNewPackageMutationVariables>(AddNewPackageDocument, options);
      }
export type AddNewPackageMutationHookResult = ReturnType<typeof useAddNewPackageMutation>;
export type AddNewPackageMutationResult = Apollo.MutationResult<AddNewPackageMutation>;
export type AddNewPackageMutationOptions = Apollo.BaseMutationOptions<AddNewPackageMutation, AddNewPackageMutationVariables>;
export const AddSubPackageDocument = gql`
    mutation AddSubPackage($input: subPackageInput!) {
  addSubPackage(input: $input) {
    success
    message
    token
  }
}
    `;
export type AddSubPackageMutationFn = Apollo.MutationFunction<AddSubPackageMutation, AddSubPackageMutationVariables>;

/**
 * __useAddSubPackageMutation__
 *
 * To run a mutation, you first call `useAddSubPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubPackageMutation, { data, loading, error }] = useAddSubPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSubPackageMutation(baseOptions?: Apollo.MutationHookOptions<AddSubPackageMutation, AddSubPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubPackageMutation, AddSubPackageMutationVariables>(AddSubPackageDocument, options);
      }
export type AddSubPackageMutationHookResult = ReturnType<typeof useAddSubPackageMutation>;
export type AddSubPackageMutationResult = Apollo.MutationResult<AddSubPackageMutation>;
export type AddSubPackageMutationOptions = Apollo.BaseMutationOptions<AddSubPackageMutation, AddSubPackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($input: updatePackage!) {
  updatePackage(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const UpdateSubPackageDocument = gql`
    mutation UpdateSubPackage($input: updateSubPackage!) {
  updateSubPackage(input: $input) {
    success
    message
    token
  }
}
    `;
export type UpdateSubPackageMutationFn = Apollo.MutationFunction<UpdateSubPackageMutation, UpdateSubPackageMutationVariables>;

/**
 * __useUpdateSubPackageMutation__
 *
 * To run a mutation, you first call `useUpdateSubPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubPackageMutation, { data, loading, error }] = useUpdateSubPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubPackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubPackageMutation, UpdateSubPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubPackageMutation, UpdateSubPackageMutationVariables>(UpdateSubPackageDocument, options);
      }
export type UpdateSubPackageMutationHookResult = ReturnType<typeof useUpdateSubPackageMutation>;
export type UpdateSubPackageMutationResult = Apollo.MutationResult<UpdateSubPackageMutation>;
export type UpdateSubPackageMutationOptions = Apollo.BaseMutationOptions<UpdateSubPackageMutation, UpdateSubPackageMutationVariables>;
export const DisablePackageDocument = gql`
    mutation DisablePackage($input: disablePackageInput!) {
  disablePackage(input: $input) {
    success
    message
    token
  }
}
    `;
export type DisablePackageMutationFn = Apollo.MutationFunction<DisablePackageMutation, DisablePackageMutationVariables>;

/**
 * __useDisablePackageMutation__
 *
 * To run a mutation, you first call `useDisablePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePackageMutation, { data, loading, error }] = useDisablePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisablePackageMutation(baseOptions?: Apollo.MutationHookOptions<DisablePackageMutation, DisablePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisablePackageMutation, DisablePackageMutationVariables>(DisablePackageDocument, options);
      }
export type DisablePackageMutationHookResult = ReturnType<typeof useDisablePackageMutation>;
export type DisablePackageMutationResult = Apollo.MutationResult<DisablePackageMutation>;
export type DisablePackageMutationOptions = Apollo.BaseMutationOptions<DisablePackageMutation, DisablePackageMutationVariables>;
export const GetCommentDocument = gql`
    query GetComment {
  getComment {
    id
    orderID
    employee {
      firstName
      lastName
      id
    }
    description
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCommentQuery__
 *
 * To run a query within a React component, call `useGetCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommentQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
      }
export function useGetCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
        }
export type GetCommentQueryHookResult = ReturnType<typeof useGetCommentQuery>;
export type GetCommentLazyQueryHookResult = ReturnType<typeof useGetCommentLazyQuery>;
export type GetCommentQueryResult = Apollo.QueryResult<GetCommentQuery, GetCommentQueryVariables>;
export const GetCommentByOrderIdDocument = gql`
    query GetCommentByOrderID($input: getCommentByOrderIDInput) {
  getCommentByOrderID(input: $input) {
    id
    orderID
    employee {
      firstName
      lastName
      createdAt
    }
    description
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCommentByOrderIdQuery__
 *
 * To run a query within a React component, call `useGetCommentByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentByOrderIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommentByOrderIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentByOrderIdQuery, GetCommentByOrderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentByOrderIdQuery, GetCommentByOrderIdQueryVariables>(GetCommentByOrderIdDocument, options);
      }
export function useGetCommentByOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentByOrderIdQuery, GetCommentByOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentByOrderIdQuery, GetCommentByOrderIdQueryVariables>(GetCommentByOrderIdDocument, options);
        }
export type GetCommentByOrderIdQueryHookResult = ReturnType<typeof useGetCommentByOrderIdQuery>;
export type GetCommentByOrderIdLazyQueryHookResult = ReturnType<typeof useGetCommentByOrderIdLazyQuery>;
export type GetCommentByOrderIdQueryResult = Apollo.QueryResult<GetCommentByOrderIdQuery, GetCommentByOrderIdQueryVariables>;
export const GetContentOrderServiceTypesDocument = gql`
    query GetContentOrderServiceTypes {
  getContentOrderServiceTypes {
    id
    serviceType
    disabled
    ContentOrderServiceTypeAttribute {
      attributeName
      id
      disabled
    }
  }
}
    `;

/**
 * __useGetContentOrderServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetContentOrderServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentOrderServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentOrderServiceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentOrderServiceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentOrderServiceTypesQuery, GetContentOrderServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentOrderServiceTypesQuery, GetContentOrderServiceTypesQueryVariables>(GetContentOrderServiceTypesDocument, options);
      }
export function useGetContentOrderServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentOrderServiceTypesQuery, GetContentOrderServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentOrderServiceTypesQuery, GetContentOrderServiceTypesQueryVariables>(GetContentOrderServiceTypesDocument, options);
        }
export type GetContentOrderServiceTypesQueryHookResult = ReturnType<typeof useGetContentOrderServiceTypesQuery>;
export type GetContentOrderServiceTypesLazyQueryHookResult = ReturnType<typeof useGetContentOrderServiceTypesLazyQuery>;
export type GetContentOrderServiceTypesQueryResult = Apollo.QueryResult<GetContentOrderServiceTypesQuery, GetContentOrderServiceTypesQueryVariables>;
export const GetAllContentOrderServiceTypesDocument = gql`
    query GetAllContentOrderServiceTypes {
  getAllContentOrderServiceTypes {
    id
    serviceType
    disabled
    ContentOrderServiceTypeAttribute {
      attributeName
      id
      disabled
    }
  }
}
    `;

/**
 * __useGetAllContentOrderServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetAllContentOrderServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContentOrderServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContentOrderServiceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContentOrderServiceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContentOrderServiceTypesQuery, GetAllContentOrderServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContentOrderServiceTypesQuery, GetAllContentOrderServiceTypesQueryVariables>(GetAllContentOrderServiceTypesDocument, options);
      }
export function useGetAllContentOrderServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContentOrderServiceTypesQuery, GetAllContentOrderServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContentOrderServiceTypesQuery, GetAllContentOrderServiceTypesQueryVariables>(GetAllContentOrderServiceTypesDocument, options);
        }
export type GetAllContentOrderServiceTypesQueryHookResult = ReturnType<typeof useGetAllContentOrderServiceTypesQuery>;
export type GetAllContentOrderServiceTypesLazyQueryHookResult = ReturnType<typeof useGetAllContentOrderServiceTypesLazyQuery>;
export type GetAllContentOrderServiceTypesQueryResult = Apollo.QueryResult<GetAllContentOrderServiceTypesQuery, GetAllContentOrderServiceTypesQueryVariables>;
export const GenerateContentOrderIdDocument = gql`
    query GenerateContentOrderID($input: generateContentOrderIDInput) {
  generateContentOrderID(input: $input)
}
    `;

/**
 * __useGenerateContentOrderIdQuery__
 *
 * To run a query within a React component, call `useGenerateContentOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateContentOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateContentOrderIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateContentOrderIdQuery(baseOptions?: Apollo.QueryHookOptions<GenerateContentOrderIdQuery, GenerateContentOrderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateContentOrderIdQuery, GenerateContentOrderIdQueryVariables>(GenerateContentOrderIdDocument, options);
      }
export function useGenerateContentOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateContentOrderIdQuery, GenerateContentOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateContentOrderIdQuery, GenerateContentOrderIdQueryVariables>(GenerateContentOrderIdDocument, options);
        }
export type GenerateContentOrderIdQueryHookResult = ReturnType<typeof useGenerateContentOrderIdQuery>;
export type GenerateContentOrderIdLazyQueryHookResult = ReturnType<typeof useGenerateContentOrderIdLazyQuery>;
export type GenerateContentOrderIdQueryResult = Apollo.QueryResult<GenerateContentOrderIdQuery, GenerateContentOrderIdQueryVariables>;
export const GetContentOrderServiceTypeAttributeDocument = gql`
    query GetContentOrderServiceTypeAttribute($input: getContentOrderServiceTypeAttributeInput) {
  getContentOrderServiceTypeAttribute(input: $input) {
    attributeName
    id
    disabled
  }
}
    `;

/**
 * __useGetContentOrderServiceTypeAttributeQuery__
 *
 * To run a query within a React component, call `useGetContentOrderServiceTypeAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentOrderServiceTypeAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentOrderServiceTypeAttributeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContentOrderServiceTypeAttributeQuery(baseOptions?: Apollo.QueryHookOptions<GetContentOrderServiceTypeAttributeQuery, GetContentOrderServiceTypeAttributeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentOrderServiceTypeAttributeQuery, GetContentOrderServiceTypeAttributeQueryVariables>(GetContentOrderServiceTypeAttributeDocument, options);
      }
export function useGetContentOrderServiceTypeAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentOrderServiceTypeAttributeQuery, GetContentOrderServiceTypeAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentOrderServiceTypeAttributeQuery, GetContentOrderServiceTypeAttributeQueryVariables>(GetContentOrderServiceTypeAttributeDocument, options);
        }
export type GetContentOrderServiceTypeAttributeQueryHookResult = ReturnType<typeof useGetContentOrderServiceTypeAttributeQuery>;
export type GetContentOrderServiceTypeAttributeLazyQueryHookResult = ReturnType<typeof useGetContentOrderServiceTypeAttributeLazyQuery>;
export type GetContentOrderServiceTypeAttributeQueryResult = Apollo.QueryResult<GetContentOrderServiceTypeAttributeQuery, GetContentOrderServiceTypeAttributeQueryVariables>;
export const PaginatedContentOrderListDocument = gql`
    query PaginatedContentOrderList($input: paginatedContentOrderListInput) {
  paginatedContentOrderList(input: $input) {
    contentOrders {
      id
      PbnName
      clientSiteURL
      wordCount
      orderStatus
      orderStartDate
      orderDueDate
      orderDescription
      cmsEmployeeID
      client {
        id
        name
      }
      cmsAdmin {
        id
        firstName
        lastName
        role
      }
      cmsEmployee {
        id
        firstName
        lastName
        role
      }
      serviceType {
        ContentOrderServiceTypeAttribute {
          serviceType {
            id
            serviceType
            disabled
          }
          disabled
          attributeName
          serviceTypeID
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedContentOrderListQuery__
 *
 * To run a query within a React component, call `usePaginatedContentOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedContentOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedContentOrderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedContentOrderListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedContentOrderListQuery, PaginatedContentOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedContentOrderListQuery, PaginatedContentOrderListQueryVariables>(PaginatedContentOrderListDocument, options);
      }
export function usePaginatedContentOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedContentOrderListQuery, PaginatedContentOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedContentOrderListQuery, PaginatedContentOrderListQueryVariables>(PaginatedContentOrderListDocument, options);
        }
export type PaginatedContentOrderListQueryHookResult = ReturnType<typeof usePaginatedContentOrderListQuery>;
export type PaginatedContentOrderListLazyQueryHookResult = ReturnType<typeof usePaginatedContentOrderListLazyQuery>;
export type PaginatedContentOrderListQueryResult = Apollo.QueryResult<PaginatedContentOrderListQuery, PaginatedContentOrderListQueryVariables>;
export const GetContentOrderDocument = gql`
    query GetContentOrder($input: getContentOrderInput) {
  getContentOrder(input: $input) {
    id
    PbnName
    clientSiteURL
    wordCount
    orderStatus
    orderStartDate
    orderDueDate
    orderDescription
    articleLink
    serviceTypeID
    clientID
    cmsAdminID
    cmsEmployeeID
    client {
      id
      name
      updatedAt
    }
    cmsEmployee {
      email
      firstName
      id
      lastName
      role
      phone
    }
    cmsAdmin {
      email
      firstName
      id
      lastName
      role
      phone
    }
    contentOrderServiceTypeAttributeValue {
      serviceTypeAttribute {
        attributeName
        disabled
        id
        serviceType {
          id
          serviceType
          disabled
        }
      }
      serviceTypeAttributeValue
    }
  }
}
    `;

/**
 * __useGetContentOrderQuery__
 *
 * To run a query within a React component, call `useGetContentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentOrderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContentOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetContentOrderQuery, GetContentOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentOrderQuery, GetContentOrderQueryVariables>(GetContentOrderDocument, options);
      }
export function useGetContentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentOrderQuery, GetContentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentOrderQuery, GetContentOrderQueryVariables>(GetContentOrderDocument, options);
        }
export type GetContentOrderQueryHookResult = ReturnType<typeof useGetContentOrderQuery>;
export type GetContentOrderLazyQueryHookResult = ReturnType<typeof useGetContentOrderLazyQuery>;
export type GetContentOrderQueryResult = Apollo.QueryResult<GetContentOrderQuery, GetContentOrderQueryVariables>;
export const PaginatedTransferRequestForEmployeeDocument = gql`
    query PaginatedTransferRequestForEmployee($input: paginatedTransferRequestForEmployeeInput) {
  paginatedTransferRequestForEmployee(input: $input) {
    requests {
      id
      siteDA
      siteDR
      siteTraffic
      priceAsked
      finalPrice
      specialPrice
      POC
      status
      createdAt
      domain {
        domainDetails {
          POC
          contactType {
            id
            contactType
          }
          contactedBy {
            id
            firstName
            lastName
            role
          }
          finalPrice
          linkInsertionPrice
          priceAsked
          serviceType {
            serviceType
            id
          }
          specialPrice
          status
        }
        id
        siteDA
        siteDR
        siteTraffic
        siteUrl
      }
      employeeRequestBy {
        id
        firstName
        lastName
        role
      }
      contactType {
        id
        contactType
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedTransferRequestForEmployeeQuery__
 *
 * To run a query within a React component, call `usePaginatedTransferRequestForEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTransferRequestForEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTransferRequestForEmployeeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedTransferRequestForEmployeeQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedTransferRequestForEmployeeQuery, PaginatedTransferRequestForEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedTransferRequestForEmployeeQuery, PaginatedTransferRequestForEmployeeQueryVariables>(PaginatedTransferRequestForEmployeeDocument, options);
      }
export function usePaginatedTransferRequestForEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedTransferRequestForEmployeeQuery, PaginatedTransferRequestForEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedTransferRequestForEmployeeQuery, PaginatedTransferRequestForEmployeeQueryVariables>(PaginatedTransferRequestForEmployeeDocument, options);
        }
export type PaginatedTransferRequestForEmployeeQueryHookResult = ReturnType<typeof usePaginatedTransferRequestForEmployeeQuery>;
export type PaginatedTransferRequestForEmployeeLazyQueryHookResult = ReturnType<typeof usePaginatedTransferRequestForEmployeeLazyQuery>;
export type PaginatedTransferRequestForEmployeeQueryResult = Apollo.QueryResult<PaginatedTransferRequestForEmployeeQuery, PaginatedTransferRequestForEmployeeQueryVariables>;
export const PaginatedTransferRequestDocument = gql`
    query PaginatedTransferRequest($input: paginatedTransferRequestInput) {
  paginatedTransferRequest(input: $input) {
    requests {
      id
      siteDA
      siteDR
      siteTraffic
      priceAsked
      finalPrice
      specialPrice
      POC
      status
      domain {
        domainDetails {
          POC
          contactType {
            id
            contactType
          }
          contactedBy {
            id
            firstName
            lastName
            role
          }
          finalPrice
          linkInsertionPrice
          priceAsked
          serviceType {
            serviceType
            id
          }
          specialPrice
          status
        }
        id
        siteDA
        siteDR
        siteTraffic
        siteUrl
      }
      employeeRequestBy {
        id
        firstName
        lastName
        role
      }
      contactType {
        id
        contactType
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedTransferRequestQuery__
 *
 * To run a query within a React component, call `usePaginatedTransferRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedTransferRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedTransferRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedTransferRequestQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedTransferRequestQuery, PaginatedTransferRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedTransferRequestQuery, PaginatedTransferRequestQueryVariables>(PaginatedTransferRequestDocument, options);
      }
export function usePaginatedTransferRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedTransferRequestQuery, PaginatedTransferRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedTransferRequestQuery, PaginatedTransferRequestQueryVariables>(PaginatedTransferRequestDocument, options);
        }
export type PaginatedTransferRequestQueryHookResult = ReturnType<typeof usePaginatedTransferRequestQuery>;
export type PaginatedTransferRequestLazyQueryHookResult = ReturnType<typeof usePaginatedTransferRequestLazyQuery>;
export type PaginatedTransferRequestQueryResult = Apollo.QueryResult<PaginatedTransferRequestQuery, PaginatedTransferRequestQueryVariables>;
export const GetTransferRequestDocument = gql`
    query GetTransferRequest($input: getTransferRequestInput) {
  getTransferRequest(input: $input) {
    id
    siteDA
    siteDR
    siteTraffic
    priceAsked
    finalPrice
    specialPrice
    linkInsertionPrice
    POC
    status
    createdAt
    domain {
      domainDetails {
        POC
        contactType {
          id
          contactType
        }
        contactedBy {
          id
          firstName
          lastName
          role
        }
        finalPrice
        linkInsertionPrice
        priceAsked
        serviceType {
          serviceType
          id
        }
        specialPrice
        status
      }
      id
      siteDA
      siteDR
      siteTraffic
      siteUrl
      DomainNiches {
        niche {
          niche
          id
          nicheAbbr
        }
      }
      siteContactDetails {
        contactDetails
        contactType {
          id
          contactType
        }
      }
    }
    employeeRequestBy {
      id
      firstName
      lastName
      role
    }
    contactType {
      id
      contactType
    }
  }
}
    `;

/**
 * __useGetTransferRequestQuery__
 *
 * To run a query within a React component, call `useGetTransferRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransferRequestQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferRequestQuery, GetTransferRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferRequestQuery, GetTransferRequestQueryVariables>(GetTransferRequestDocument, options);
      }
export function useGetTransferRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferRequestQuery, GetTransferRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferRequestQuery, GetTransferRequestQueryVariables>(GetTransferRequestDocument, options);
        }
export type GetTransferRequestQueryHookResult = ReturnType<typeof useGetTransferRequestQuery>;
export type GetTransferRequestLazyQueryHookResult = ReturnType<typeof useGetTransferRequestLazyQuery>;
export type GetTransferRequestQueryResult = Apollo.QueryResult<GetTransferRequestQuery, GetTransferRequestQueryVariables>;
export const GetEmployeeWithRoleDocument = gql`
    query GetEmployeeWithRole($input: getEmployeeWithRoleInput) {
  getEmployeeWithRole(input: $input) {
    id
    firstName
    lastName
    email
    phone
    role
  }
}
    `;

/**
 * __useGetEmployeeWithRoleQuery__
 *
 * To run a query within a React component, call `useGetEmployeeWithRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeWithRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeWithRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmployeeWithRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeWithRoleQuery, GetEmployeeWithRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeWithRoleQuery, GetEmployeeWithRoleQueryVariables>(GetEmployeeWithRoleDocument, options);
      }
export function useGetEmployeeWithRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeWithRoleQuery, GetEmployeeWithRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeWithRoleQuery, GetEmployeeWithRoleQueryVariables>(GetEmployeeWithRoleDocument, options);
        }
export type GetEmployeeWithRoleQueryHookResult = ReturnType<typeof useGetEmployeeWithRoleQuery>;
export type GetEmployeeWithRoleLazyQueryHookResult = ReturnType<typeof useGetEmployeeWithRoleLazyQuery>;
export type GetEmployeeWithRoleQueryResult = Apollo.QueryResult<GetEmployeeWithRoleQuery, GetEmployeeWithRoleQueryVariables>;
export const GetEmployeeByEmailDocument = gql`
    query GetEmployeeByEmail($email: String!) {
  getEmployeeByEmail(email: $email) {
    id
    firstName
    lastName
    email
    phone
    password
    isActive
    createdAt
    updatedAt
    role
  }
}
    `;

/**
 * __useGetEmployeeByEmailQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmployeeByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>(GetEmployeeByEmailDocument, options);
      }
export function useGetEmployeeByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>(GetEmployeeByEmailDocument, options);
        }
export type GetEmployeeByEmailQueryHookResult = ReturnType<typeof useGetEmployeeByEmailQuery>;
export type GetEmployeeByEmailLazyQueryHookResult = ReturnType<typeof useGetEmployeeByEmailLazyQuery>;
export type GetEmployeeByEmailQueryResult = Apollo.QueryResult<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>;
export const GetTodosDocument = gql`
    query GetTodos($input: getToDoByIdInput) {
  getTodosById(input: $input) {
    id
    task
    complete
    employeeID
    date
  }
}
    `;

/**
 * __useGetTodosQuery__
 *
 * To run a query within a React component, call `useGetTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodosQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTodosQuery(baseOptions?: Apollo.QueryHookOptions<GetTodosQuery, GetTodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodosQuery, GetTodosQueryVariables>(GetTodosDocument, options);
      }
export function useGetTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodosQuery, GetTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodosQuery, GetTodosQueryVariables>(GetTodosDocument, options);
        }
export type GetTodosQueryHookResult = ReturnType<typeof useGetTodosQuery>;
export type GetTodosLazyQueryHookResult = ReturnType<typeof useGetTodosLazyQuery>;
export type GetTodosQueryResult = Apollo.QueryResult<GetTodosQuery, GetTodosQueryVariables>;
export const GetNichesDocument = gql`
    query GetNiches {
  getNiches {
    id
    niche
    nicheAbbr
    disabled
  }
}
    `;

/**
 * __useGetNichesQuery__
 *
 * To run a query within a React component, call `useGetNichesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNichesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNichesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNichesQuery(baseOptions?: Apollo.QueryHookOptions<GetNichesQuery, GetNichesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNichesQuery, GetNichesQueryVariables>(GetNichesDocument, options);
      }
export function useGetNichesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNichesQuery, GetNichesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNichesQuery, GetNichesQueryVariables>(GetNichesDocument, options);
        }
export type GetNichesQueryHookResult = ReturnType<typeof useGetNichesQuery>;
export type GetNichesLazyQueryHookResult = ReturnType<typeof useGetNichesLazyQuery>;
export type GetNichesQueryResult = Apollo.QueryResult<GetNichesQuery, GetNichesQueryVariables>;
export const AllNichesDocument = gql`
    query AllNiches {
  allNiches {
    id
    niche
    nicheAbbr
    disabled
  }
}
    `;

/**
 * __useAllNichesQuery__
 *
 * To run a query within a React component, call `useAllNichesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNichesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNichesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllNichesQuery(baseOptions?: Apollo.QueryHookOptions<AllNichesQuery, AllNichesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNichesQuery, AllNichesQueryVariables>(AllNichesDocument, options);
      }
export function useAllNichesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNichesQuery, AllNichesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNichesQuery, AllNichesQueryVariables>(AllNichesDocument, options);
        }
export type AllNichesQueryHookResult = ReturnType<typeof useAllNichesQuery>;
export type AllNichesLazyQueryHookResult = ReturnType<typeof useAllNichesLazyQuery>;
export type AllNichesQueryResult = Apollo.QueryResult<AllNichesQuery, AllNichesQueryVariables>;
export const PaginatedClientSelectedSiteListDocument = gql`
    query PaginatedClientSelectedSiteList($input: paginatedClientSelectedSiteListInput) {
  paginatedClientSelectedSiteList(input: $input) {
    totalPages
    totalRows
    siteUrls {
      id
      orderID
      siteURL
    }
  }
}
    `;

/**
 * __usePaginatedClientSelectedSiteListQuery__
 *
 * To run a query within a React component, call `usePaginatedClientSelectedSiteListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedClientSelectedSiteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedClientSelectedSiteListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedClientSelectedSiteListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedClientSelectedSiteListQuery, PaginatedClientSelectedSiteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedClientSelectedSiteListQuery, PaginatedClientSelectedSiteListQueryVariables>(PaginatedClientSelectedSiteListDocument, options);
      }
export function usePaginatedClientSelectedSiteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedClientSelectedSiteListQuery, PaginatedClientSelectedSiteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedClientSelectedSiteListQuery, PaginatedClientSelectedSiteListQueryVariables>(PaginatedClientSelectedSiteListDocument, options);
        }
export type PaginatedClientSelectedSiteListQueryHookResult = ReturnType<typeof usePaginatedClientSelectedSiteListQuery>;
export type PaginatedClientSelectedSiteListLazyQueryHookResult = ReturnType<typeof usePaginatedClientSelectedSiteListLazyQuery>;
export type PaginatedClientSelectedSiteListQueryResult = Apollo.QueryResult<PaginatedClientSelectedSiteListQuery, PaginatedClientSelectedSiteListQueryVariables>;
export const GetOrderByIdDocument = gql`
    query GetOrderByID($input: orderIDInput) {
  getOrderByID(input: $input) {
    id
    createdAt
    updatedAt
    orderStartDate
    orderDueDate
    ArticleCounts
    paymentStatus
    orderStatus
    clientSiteURL
    requiredDA
    requiredDR
    createdBy {
      id
      firstName
      lastName
      email
      role
    }
    client {
      id
      name
      updatedAt
      clientBaseURL {
        id
        baseURL
      }
    }
    seoOrderManager {
      id
      firstName
      lastName
      email
      role
    }
    SeoOrders {
      id
      dateOfAssignment
      instructionsSeoEmployee
      orderStatus
      updatedAt
      seoEmp {
        id
        firstName
        lastName
        email
        role
      }
      LiveLinks {
        id
        liveLinks
      }
      CmsOrders {
        id
        instructionCmsAdmin
        instructionCmsEmp
        cmsAdmin {
          id
          firstName
          lastName
          email
          role
        }
        Articles {
          id
          articleLink
        }
        cmsEmp {
          id
          firstName
          lastName
          email
          role
        }
        dateOfAssignmentCmsEmployee
        dateOfAssignmentCmsAdmin
        updatedAt
        orderStatus
      }
    }
    package {
      id
      packageName
      description
      price
      isDisabled
      SubPackage {
        id
        subPackageName
        packageDescription
        requiredDA
        price
      }
    }
  }
}
    `;

/**
 * __useGetOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
      }
export function useGetOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
        }
export type GetOrderByIdQueryHookResult = ReturnType<typeof useGetOrderByIdQuery>;
export type GetOrderByIdLazyQueryHookResult = ReturnType<typeof useGetOrderByIdLazyQuery>;
export type GetOrderByIdQueryResult = Apollo.QueryResult<GetOrderByIdQuery, GetOrderByIdQueryVariables>;
export const GetSeoOrderByIdDocument = gql`
    query GetSeoOrderByID($input: seoOrderIDInput) {
  getSeoOrderByID(input: $input) {
    id
    dateOfAssignment
    instructionsSeoEmployee
    orderStatus
    updatedAt
    seoEmp {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
    CmsOrders {
      id
      instructionCmsAdmin
      instructionCmsEmp
      cmsAdmin {
        id
        firstName
        lastName
        email
        phone
        password
        isActive
        createdAt
        updatedAt
        role
      }
      cmsEmp {
        id
        firstName
        lastName
        email
        phone
        password
        isActive
        createdAt
        updatedAt
        role
      }
      dateOfAssignmentCmsEmployee
      dateOfAssignmentCmsAdmin
      updatedAt
      orderStatus
      Articles {
        id
        articleLink
        articleWordCount
        niche
        keywords
        submissionDate
        publishingDate
      }
    }
    LiveLinks {
      id
      seoOrderID
      liveLinks
    }
    ClientSiteUrl {
      id
      clientSiteURL
      keyword
      requiredDA
      requiredDR
      updatedAt
    }
    order {
      orderDueDate
      orderStartDate
      orderStatus
      requiredDA
      requiredDR
      SeoOrders {
        instructionsSeoEmployee
      }
      ArticleCounts
      client {
        id
        name
        updatedAt
        clientBaseURL {
          id
          clientID
          baseURL
        }
      }
    }
  }
}
    `;

/**
 * __useGetSeoOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetSeoOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoOrderByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSeoOrderByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSeoOrderByIdQuery, GetSeoOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoOrderByIdQuery, GetSeoOrderByIdQueryVariables>(GetSeoOrderByIdDocument, options);
      }
export function useGetSeoOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoOrderByIdQuery, GetSeoOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoOrderByIdQuery, GetSeoOrderByIdQueryVariables>(GetSeoOrderByIdDocument, options);
        }
export type GetSeoOrderByIdQueryHookResult = ReturnType<typeof useGetSeoOrderByIdQuery>;
export type GetSeoOrderByIdLazyQueryHookResult = ReturnType<typeof useGetSeoOrderByIdLazyQuery>;
export type GetSeoOrderByIdQueryResult = Apollo.QueryResult<GetSeoOrderByIdQuery, GetSeoOrderByIdQueryVariables>;
export const GetCmsOrderByIdDocument = gql`
    query GetCmsOrderByID($input: cmsOrderIDInput) {
  getCmsOrderByID(input: $input) {
    id
    instructionCmsAdmin
    instructionCmsEmp
    cmsAdmin {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
    cmsEmp {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
    dateOfAssignmentCmsEmployee
    dateOfAssignmentCmsAdmin
    updatedAt
    orderStatus
    seoOrder {
      ClientSiteUrl {
        id
        clientSiteURL
        keyword
        requiredDA
        requiredDR
        updatedAt
      }
      LiveLinks {
        id
        seoOrderID
        liveLinks
      }
      order {
        id
        ArticleCounts
        client {
          id
          name
          updatedAt
          clientBaseURL {
            id
            clientID
            baseURL
          }
        }
        requiredDA
        requiredDR
        orderDueDate
        orderStartDate
      }
    }
    Articles {
      id
      articleLink
      articleWordCount
      niche
      keywords
      submissionDate
      publishingDate
    }
  }
}
    `;

/**
 * __useGetCmsOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetCmsOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsOrderByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCmsOrderByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCmsOrderByIdQuery, GetCmsOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsOrderByIdQuery, GetCmsOrderByIdQueryVariables>(GetCmsOrderByIdDocument, options);
      }
export function useGetCmsOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsOrderByIdQuery, GetCmsOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsOrderByIdQuery, GetCmsOrderByIdQueryVariables>(GetCmsOrderByIdDocument, options);
        }
export type GetCmsOrderByIdQueryHookResult = ReturnType<typeof useGetCmsOrderByIdQuery>;
export type GetCmsOrderByIdLazyQueryHookResult = ReturnType<typeof useGetCmsOrderByIdLazyQuery>;
export type GetCmsOrderByIdQueryResult = Apollo.QueryResult<GetCmsOrderByIdQuery, GetCmsOrderByIdQueryVariables>;
export const PaginatedSubTaskListDocument = gql`
    query PaginatedSubTaskList($input: paginatedSubTaskListInput) {
  paginatedSubTaskList(input: $input) {
    seoOrderList {
      id
      dateOfAssignment
      instructionsSeoEmployee
      orderStatus
      selectedSite
      actualDA
      updatedAt
      seoEmp {
        email
        firstName
        id
        lastName
        phone
        role
      }
      ClientSiteUrl {
        id
        clientSiteURL
        keyword
        requiredDA
        requiredDR
        updatedAt
      }
      CmsOrders {
        id
        instructionCmsAdmin
        instructionCmsEmp
        cmsAdmin {
          firstName
          email
          id
          lastName
          phone
          role
        }
        cmsEmp {
          email
          firstName
          id
          lastName
          role
          phone
        }
        dateOfAssignmentCmsEmployee
        dateOfAssignmentCmsAdmin
        orderStatus
        Articles {
          id
          articleLink
        }
      }
      LiveLinks {
        id
        liveLinks
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedSubTaskListQuery__
 *
 * To run a query within a React component, call `usePaginatedSubTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedSubTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedSubTaskListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedSubTaskListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedSubTaskListQuery, PaginatedSubTaskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedSubTaskListQuery, PaginatedSubTaskListQueryVariables>(PaginatedSubTaskListDocument, options);
      }
export function usePaginatedSubTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedSubTaskListQuery, PaginatedSubTaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedSubTaskListQuery, PaginatedSubTaskListQueryVariables>(PaginatedSubTaskListDocument, options);
        }
export type PaginatedSubTaskListQueryHookResult = ReturnType<typeof usePaginatedSubTaskListQuery>;
export type PaginatedSubTaskListLazyQueryHookResult = ReturnType<typeof usePaginatedSubTaskListLazyQuery>;
export type PaginatedSubTaskListQueryResult = Apollo.QueryResult<PaginatedSubTaskListQuery, PaginatedSubTaskListQueryVariables>;
export const GetOrderGeneratedIdDocument = gql`
    query getOrderGeneratedID($input: getOrderGeneratedIDInput) {
  getOrderGeneratedID(input: $input)
}
    `;

/**
 * __useGetOrderGeneratedIdQuery__
 *
 * To run a query within a React component, call `useGetOrderGeneratedIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderGeneratedIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderGeneratedIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderGeneratedIdQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderGeneratedIdQuery, GetOrderGeneratedIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderGeneratedIdQuery, GetOrderGeneratedIdQueryVariables>(GetOrderGeneratedIdDocument, options);
      }
export function useGetOrderGeneratedIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderGeneratedIdQuery, GetOrderGeneratedIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderGeneratedIdQuery, GetOrderGeneratedIdQueryVariables>(GetOrderGeneratedIdDocument, options);
        }
export type GetOrderGeneratedIdQueryHookResult = ReturnType<typeof useGetOrderGeneratedIdQuery>;
export type GetOrderGeneratedIdLazyQueryHookResult = ReturnType<typeof useGetOrderGeneratedIdLazyQuery>;
export type GetOrderGeneratedIdQueryResult = Apollo.QueryResult<GetOrderGeneratedIdQuery, GetOrderGeneratedIdQueryVariables>;
export const GetAllOrderTypesDocument = gql`
    query GetAllOrderTypes {
  getAllOrderTypes {
    id
    initials
    orderType
  }
}
    `;

/**
 * __useGetAllOrderTypesQuery__
 *
 * To run a query within a React component, call `useGetAllOrderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrderTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrderTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllOrderTypesQuery, GetAllOrderTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOrderTypesQuery, GetAllOrderTypesQueryVariables>(GetAllOrderTypesDocument, options);
      }
export function useGetAllOrderTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrderTypesQuery, GetAllOrderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOrderTypesQuery, GetAllOrderTypesQueryVariables>(GetAllOrderTypesDocument, options);
        }
export type GetAllOrderTypesQueryHookResult = ReturnType<typeof useGetAllOrderTypesQuery>;
export type GetAllOrderTypesLazyQueryHookResult = ReturnType<typeof useGetAllOrderTypesLazyQuery>;
export type GetAllOrderTypesQueryResult = Apollo.QueryResult<GetAllOrderTypesQuery, GetAllOrderTypesQueryVariables>;
export const VerifyDomainDocument = gql`
    query VerifyDomain($input: verifyDomainInput) {
  verifyDomain(input: $input) {
    verified
    contactedBy {
      firstName
      email
      id
      lastName
    }
    priceAsked
    finalPrice
    specialPrice
    domainID
    contactTypeID
    serviceType
    serviceTypeID
    siteDA
    siteDR
    siteTraffic
  }
}
    `;

/**
 * __useVerifyDomainQuery__
 *
 * To run a query within a React component, call `useVerifyDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyDomainQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyDomainQuery(baseOptions?: Apollo.QueryHookOptions<VerifyDomainQuery, VerifyDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyDomainQuery, VerifyDomainQueryVariables>(VerifyDomainDocument, options);
      }
export function useVerifyDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyDomainQuery, VerifyDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyDomainQuery, VerifyDomainQueryVariables>(VerifyDomainDocument, options);
        }
export type VerifyDomainQueryHookResult = ReturnType<typeof useVerifyDomainQuery>;
export type VerifyDomainLazyQueryHookResult = ReturnType<typeof useVerifyDomainLazyQuery>;
export type VerifyDomainQueryResult = Apollo.QueryResult<VerifyDomainQuery, VerifyDomainQueryVariables>;
export const GetAllServiceTypeDocument = gql`
    query GetAllServiceType {
  getAllServiceType {
    id
    serviceType
  }
}
    `;

/**
 * __useGetAllServiceTypeQuery__
 *
 * To run a query within a React component, call `useGetAllServiceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServiceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServiceTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServiceTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllServiceTypeQuery, GetAllServiceTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServiceTypeQuery, GetAllServiceTypeQueryVariables>(GetAllServiceTypeDocument, options);
      }
export function useGetAllServiceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServiceTypeQuery, GetAllServiceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServiceTypeQuery, GetAllServiceTypeQueryVariables>(GetAllServiceTypeDocument, options);
        }
export type GetAllServiceTypeQueryHookResult = ReturnType<typeof useGetAllServiceTypeQuery>;
export type GetAllServiceTypeLazyQueryHookResult = ReturnType<typeof useGetAllServiceTypeLazyQuery>;
export type GetAllServiceTypeQueryResult = Apollo.QueryResult<GetAllServiceTypeQuery, GetAllServiceTypeQueryVariables>;
export const MasterSheetDocument = gql`
    query MasterSheet($input: getDomainInput) {
  masterSheet(input: $input) {
    id
    siteUrl
    siteDA
    siteDR
    siteTraffic
    domainDetails {
      priceAsked
      finalPrice
      specialPrice
      linkInsertionPrice
      dateOfContact
      status
      POC
      updatedAt
      contactedBy {
        id
        firstName
        lastName
        email
        role
      }
      contactType {
        id
        contactType
      }
      serviceType {
        id
        serviceType
      }
    }
  }
}
    `;

/**
 * __useMasterSheetQuery__
 *
 * To run a query within a React component, call `useMasterSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterSheetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMasterSheetQuery(baseOptions?: Apollo.QueryHookOptions<MasterSheetQuery, MasterSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MasterSheetQuery, MasterSheetQueryVariables>(MasterSheetDocument, options);
      }
export function useMasterSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MasterSheetQuery, MasterSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MasterSheetQuery, MasterSheetQueryVariables>(MasterSheetDocument, options);
        }
export type MasterSheetQueryHookResult = ReturnType<typeof useMasterSheetQuery>;
export type MasterSheetLazyQueryHookResult = ReturnType<typeof useMasterSheetLazyQuery>;
export type MasterSheetQueryResult = Apollo.QueryResult<MasterSheetQuery, MasterSheetQueryVariables>;
export const DomainDocument = gql`
    query Domain($input: domainIDInput) {
  domain(input: $input) {
    id
    siteUrl
    siteDA
    siteDR
    siteTraffic
    domainDetails {
      priceAsked
      finalPrice
      specialPrice
      linkInsertionPrice
      dateOfContact
      status
      POC
      updatedAt
      contactedBy {
        id
        firstName
        lastName
        email
        role
      }
      contactType {
        id
        contactType
      }
      serviceType {
        id
        serviceType
      }
    }
    siteContactDetails {
      contactDetails
      updatedAt
      contactType {
        id
        contactType
        updatedAt
      }
    }
    DomainNiches {
      updatedAt
      niche {
        niche
        nicheAbbr
        disabled
      }
    }
    createdAt
    DomainMasterSheetComments {
      Employee {
        firstName
        id
        lastName
        role
      }
      description
      id
    }
    updatedAt
  }
}
    `;

/**
 * __useDomainQuery__
 *
 * To run a query within a React component, call `useDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDomainQuery(baseOptions?: Apollo.QueryHookOptions<DomainQuery, DomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
      }
export function useDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainQuery, DomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
        }
export type DomainQueryHookResult = ReturnType<typeof useDomainQuery>;
export type DomainLazyQueryHookResult = ReturnType<typeof useDomainLazyQuery>;
export type DomainQueryResult = Apollo.QueryResult<DomainQuery, DomainQueryVariables>;
export const GetAllSiteContactDetailsForDomainDocument = gql`
    query getAllSiteContactDetailsForDomain($input: domainIDInput) {
  getAllSiteContactDetailsForDomain(input: $input)
}
    `;

/**
 * __useGetAllSiteContactDetailsForDomainQuery__
 *
 * To run a query within a React component, call `useGetAllSiteContactDetailsForDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSiteContactDetailsForDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSiteContactDetailsForDomainQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllSiteContactDetailsForDomainQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSiteContactDetailsForDomainQuery, GetAllSiteContactDetailsForDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSiteContactDetailsForDomainQuery, GetAllSiteContactDetailsForDomainQueryVariables>(GetAllSiteContactDetailsForDomainDocument, options);
      }
export function useGetAllSiteContactDetailsForDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSiteContactDetailsForDomainQuery, GetAllSiteContactDetailsForDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSiteContactDetailsForDomainQuery, GetAllSiteContactDetailsForDomainQueryVariables>(GetAllSiteContactDetailsForDomainDocument, options);
        }
export type GetAllSiteContactDetailsForDomainQueryHookResult = ReturnType<typeof useGetAllSiteContactDetailsForDomainQuery>;
export type GetAllSiteContactDetailsForDomainLazyQueryHookResult = ReturnType<typeof useGetAllSiteContactDetailsForDomainLazyQuery>;
export type GetAllSiteContactDetailsForDomainQueryResult = Apollo.QueryResult<GetAllSiteContactDetailsForDomainQuery, GetAllSiteContactDetailsForDomainQueryVariables>;
export const GetAllNichesForDomainDocument = gql`
    query getAllNichesForDomain($input: domainIDInput) {
  getAllNichesForDomain(input: $input)
}
    `;

/**
 * __useGetAllNichesForDomainQuery__
 *
 * To run a query within a React component, call `useGetAllNichesForDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNichesForDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNichesForDomainQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllNichesForDomainQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNichesForDomainQuery, GetAllNichesForDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNichesForDomainQuery, GetAllNichesForDomainQueryVariables>(GetAllNichesForDomainDocument, options);
      }
export function useGetAllNichesForDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNichesForDomainQuery, GetAllNichesForDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNichesForDomainQuery, GetAllNichesForDomainQueryVariables>(GetAllNichesForDomainDocument, options);
        }
export type GetAllNichesForDomainQueryHookResult = ReturnType<typeof useGetAllNichesForDomainQuery>;
export type GetAllNichesForDomainLazyQueryHookResult = ReturnType<typeof useGetAllNichesForDomainLazyQuery>;
export type GetAllNichesForDomainQueryResult = Apollo.QueryResult<GetAllNichesForDomainQuery, GetAllNichesForDomainQueryVariables>;
export const PaginatedMasterSheetDocument = gql`
    query PaginatedMasterSheet($input: paginateDmsInput) {
  paginatedMasterSheet(input: $input) {
    dms {
      id
      siteUrl
      siteDA
      siteDR
      siteTraffic
      ahrefTraffic
      createdAt
      updatedAt
      DomainNiches {
        niche {
          id
          niche
          nicheAbbr
          disabled
          createdAt
          updatedAt
        }
      }
      domainDetails {
        priceAsked
        finalPrice
        specialPrice
        dateOfContact
        status
        updatedAt
        POC
        linkInsertionPrice
        contactedBy {
          id
          firstName
          lastName
          email
          phone
          password
          role
          isActive
          createdAt
          updatedAt
        }
        contactType {
          id
          contactType
          updatedAt
        }
        serviceType {
          id
          serviceType
          updatedAt
        }
      }
      siteContactDetails {
        contactDetails
        contactType {
          id
          contactType
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedMasterSheetQuery__
 *
 * To run a query within a React component, call `usePaginatedMasterSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMasterSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMasterSheetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedMasterSheetQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedMasterSheetQuery, PaginatedMasterSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedMasterSheetQuery, PaginatedMasterSheetQueryVariables>(PaginatedMasterSheetDocument, options);
      }
export function usePaginatedMasterSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedMasterSheetQuery, PaginatedMasterSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedMasterSheetQuery, PaginatedMasterSheetQueryVariables>(PaginatedMasterSheetDocument, options);
        }
export type PaginatedMasterSheetQueryHookResult = ReturnType<typeof usePaginatedMasterSheetQuery>;
export type PaginatedMasterSheetLazyQueryHookResult = ReturnType<typeof usePaginatedMasterSheetLazyQuery>;
export type PaginatedMasterSheetQueryResult = Apollo.QueryResult<PaginatedMasterSheetQuery, PaginatedMasterSheetQueryVariables>;
export const GetAllNichesDocument = gql`
    query GetAllNiches {
  getAllNiches
}
    `;

/**
 * __useGetAllNichesQuery__
 *
 * To run a query within a React component, call `useGetAllNichesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNichesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNichesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNichesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNichesQuery, GetAllNichesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNichesQuery, GetAllNichesQueryVariables>(GetAllNichesDocument, options);
      }
export function useGetAllNichesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNichesQuery, GetAllNichesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNichesQuery, GetAllNichesQueryVariables>(GetAllNichesDocument, options);
        }
export type GetAllNichesQueryHookResult = ReturnType<typeof useGetAllNichesQuery>;
export type GetAllNichesLazyQueryHookResult = ReturnType<typeof useGetAllNichesLazyQuery>;
export type GetAllNichesQueryResult = Apollo.QueryResult<GetAllNichesQuery, GetAllNichesQueryVariables>;
export const GetAllContactTypeDocument = gql`
    query GetAllContactType {
  getAllContactType {
    id
    contactType
  }
}
    `;

/**
 * __useGetAllContactTypeQuery__
 *
 * To run a query within a React component, call `useGetAllContactTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContactTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactTypeQuery, GetAllContactTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactTypeQuery, GetAllContactTypeQueryVariables>(GetAllContactTypeDocument, options);
      }
export function useGetAllContactTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactTypeQuery, GetAllContactTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactTypeQuery, GetAllContactTypeQueryVariables>(GetAllContactTypeDocument, options);
        }
export type GetAllContactTypeQueryHookResult = ReturnType<typeof useGetAllContactTypeQuery>;
export type GetAllContactTypeLazyQueryHookResult = ReturnType<typeof useGetAllContactTypeLazyQuery>;
export type GetAllContactTypeQueryResult = Apollo.QueryResult<GetAllContactTypeQuery, GetAllContactTypeQueryVariables>;
export const GetEmployeeUsingTokenDocument = gql`
    query GetEmployeeUsingToken {
  getEmployeeUsingToken {
    id
    firstName
    lastName
    email
    phone
    password
    isActive
    createdAt
    updatedAt
    role
  }
}
    `;

/**
 * __useGetEmployeeUsingTokenQuery__
 *
 * To run a query within a React component, call `useGetEmployeeUsingTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeUsingTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeUsingTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeUsingTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeUsingTokenQuery, GetEmployeeUsingTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeUsingTokenQuery, GetEmployeeUsingTokenQueryVariables>(GetEmployeeUsingTokenDocument, options);
      }
export function useGetEmployeeUsingTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeUsingTokenQuery, GetEmployeeUsingTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeUsingTokenQuery, GetEmployeeUsingTokenQueryVariables>(GetEmployeeUsingTokenDocument, options);
        }
export type GetEmployeeUsingTokenQueryHookResult = ReturnType<typeof useGetEmployeeUsingTokenQuery>;
export type GetEmployeeUsingTokenLazyQueryHookResult = ReturnType<typeof useGetEmployeeUsingTokenLazyQuery>;
export type GetEmployeeUsingTokenQueryResult = Apollo.QueryResult<GetEmployeeUsingTokenQuery, GetEmployeeUsingTokenQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees {
  getEmployees {
    id
    firstName
    lastName
    email
    phone
    password
    role
    isActive
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetEmployeeIdDocument = gql`
    query GetEmployeeId($getEmployeeIdId: Int) {
  getEmployeeId(id: $getEmployeeIdId) {
    id
    firstName
    lastName
    email
    phone
    password
    isActive
    createdAt
    updatedAt
    role
  }
}
    `;

/**
 * __useGetEmployeeIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeIdQuery({
 *   variables: {
 *      getEmployeeIdId: // value for 'getEmployeeIdId'
 *   },
 * });
 */
export function useGetEmployeeIdQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeIdQuery, GetEmployeeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeIdQuery, GetEmployeeIdQueryVariables>(GetEmployeeIdDocument, options);
      }
export function useGetEmployeeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeIdQuery, GetEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeIdQuery, GetEmployeeIdQueryVariables>(GetEmployeeIdDocument, options);
        }
export type GetEmployeeIdQueryHookResult = ReturnType<typeof useGetEmployeeIdQuery>;
export type GetEmployeeIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeIdLazyQuery>;
export type GetEmployeeIdQueryResult = Apollo.QueryResult<GetEmployeeIdQuery, GetEmployeeIdQueryVariables>;
export const PaginatedEmployeeListDocument = gql`
    query PaginatedEmployeeList($input: paginateEmpInput) {
  paginatedEmployeeList(input: $input) {
    emplo {
      createdAt
      email
      firstName
      id
      isActive
      lastName
      password
      phone
      role
      updatedAt
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedEmployeeListQuery__
 *
 * To run a query within a React component, call `usePaginatedEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedEmployeeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedEmployeeListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedEmployeeListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedEmployeeListQuery, PaginatedEmployeeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedEmployeeListQuery, PaginatedEmployeeListQueryVariables>(PaginatedEmployeeListDocument, options);
      }
export function usePaginatedEmployeeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedEmployeeListQuery, PaginatedEmployeeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedEmployeeListQuery, PaginatedEmployeeListQueryVariables>(PaginatedEmployeeListDocument, options);
        }
export type PaginatedEmployeeListQueryHookResult = ReturnType<typeof usePaginatedEmployeeListQuery>;
export type PaginatedEmployeeListLazyQueryHookResult = ReturnType<typeof usePaginatedEmployeeListLazyQuery>;
export type PaginatedEmployeeListQueryResult = Apollo.QueryResult<PaginatedEmployeeListQuery, PaginatedEmployeeListQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  getNotifications {
    id
    fromEmployeeID
    toEmployeeID
    title
    date
    description
    status
    redirectUrl
    fromEmployeeNotification {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
    toEmployeeNotification {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetCountsDocument = gql`
    query GetCounts {
  getCounts {
    outreachedDMSCounts
    doneDMSCounts
    negotiatingDMSCounts
  }
}
    `;

/**
 * __useGetCountsQuery__
 *
 * To run a query within a React component, call `useGetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountsQuery, GetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountsQuery, GetCountsQueryVariables>(GetCountsDocument, options);
      }
export function useGetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountsQuery, GetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountsQuery, GetCountsQueryVariables>(GetCountsDocument, options);
        }
export type GetCountsQueryHookResult = ReturnType<typeof useGetCountsQuery>;
export type GetCountsLazyQueryHookResult = ReturnType<typeof useGetCountsLazyQuery>;
export type GetCountsQueryResult = Apollo.QueryResult<GetCountsQuery, GetCountsQueryVariables>;
export const GetNotificationByIdDocument = gql`
    query GetNotificationById($input: getNotificationByIdInput) {
  getNotificationById(input: $input) {
    id
    fromEmployeeID
    toEmployeeID
    title
    date
    description
    status
    redirectUrl
    fromEmployeeNotification {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
    toEmployeeNotification {
      id
      firstName
      lastName
      email
      phone
      password
      isActive
      createdAt
      updatedAt
      role
    }
  }
}
    `;

/**
 * __useGetNotificationByIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNotificationByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>(GetNotificationByIdDocument, options);
      }
export function useGetNotificationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>(GetNotificationByIdDocument, options);
        }
export type GetNotificationByIdQueryHookResult = ReturnType<typeof useGetNotificationByIdQuery>;
export type GetNotificationByIdLazyQueryHookResult = ReturnType<typeof useGetNotificationByIdLazyQuery>;
export type GetNotificationByIdQueryResult = Apollo.QueryResult<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>;
export const PaginatedOrderListDocument = gql`
    query PaginatedOrderList($input: paginatedOrderListInput) {
  paginatedOrderList(input: $input) {
    orderList {
      id
      requiredDA
      requiredDR
      clientSiteURL
      orderStartDate
      orderDueDate
      ArticleCounts
      paymentStatus
      orderStatus
      createdAt
      updatedAt
      createdBy {
        id
        firstName
        lastName
        email
        role
        phone
      }
      client {
        id
        name
        updatedAt
        clientBaseURL {
          id
          clientID
          baseURL
        }
      }
      seoOrderManager {
        id
        firstName
        lastName
        email
        role
        phone
      }
      SeoOrders {
        id
        dateOfAssignment
        instructionsSeoEmployee
        orderStatus
        updatedAt
        seoEmp {
          id
          firstName
          lastName
          email
          role
          phone
        }
        CmsOrders {
          id
          instructionCmsAdmin
          instructionCmsEmp
          cmsAdmin {
            id
            firstName
            lastName
            email
            role
            phone
          }
          cmsEmp {
            id
            firstName
            lastName
            email
            role
            phone
          }
          dateOfAssignmentCmsEmployee
          dateOfAssignmentCmsAdmin
          updatedAt
          orderStatus
        }
      }
      package {
        description
        id
        isDisabled
        packageName
        price
        SubPackage {
          id
          subPackageName
          packageDescription
          requiredDA
          price
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedOrderListQuery__
 *
 * To run a query within a React component, call `usePaginatedOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedOrderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedOrderListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedOrderListQuery, PaginatedOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedOrderListQuery, PaginatedOrderListQueryVariables>(PaginatedOrderListDocument, options);
      }
export function usePaginatedOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedOrderListQuery, PaginatedOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedOrderListQuery, PaginatedOrderListQueryVariables>(PaginatedOrderListDocument, options);
        }
export type PaginatedOrderListQueryHookResult = ReturnType<typeof usePaginatedOrderListQuery>;
export type PaginatedOrderListLazyQueryHookResult = ReturnType<typeof usePaginatedOrderListLazyQuery>;
export type PaginatedOrderListQueryResult = Apollo.QueryResult<PaginatedOrderListQuery, PaginatedOrderListQueryVariables>;
export const PaginatedSeoOrderListDocument = gql`
    query PaginatedSeoOrderList($input: paginatedSeoOrderListInput) {
  paginatedSeoOrderList(input: $input) {
    seoOrderList {
      id
      ClientSiteUrl {
        clientSiteURL
        id
        keyword
        requiredDA
        requiredDR
      }
      order {
        ArticleCounts
        client {
          id
          name
        }
        id
        orderDueDate
        orderStartDate
        requiredDA
        requiredDR
        orderStatus
        paymentStatus
        clientSiteURL
      }
      orderStatus
      seoEmp {
        email
        firstName
        id
        lastName
        phone
        role
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedSeoOrderListQuery__
 *
 * To run a query within a React component, call `usePaginatedSeoOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedSeoOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedSeoOrderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedSeoOrderListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedSeoOrderListQuery, PaginatedSeoOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedSeoOrderListQuery, PaginatedSeoOrderListQueryVariables>(PaginatedSeoOrderListDocument, options);
      }
export function usePaginatedSeoOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedSeoOrderListQuery, PaginatedSeoOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedSeoOrderListQuery, PaginatedSeoOrderListQueryVariables>(PaginatedSeoOrderListDocument, options);
        }
export type PaginatedSeoOrderListQueryHookResult = ReturnType<typeof usePaginatedSeoOrderListQuery>;
export type PaginatedSeoOrderListLazyQueryHookResult = ReturnType<typeof usePaginatedSeoOrderListLazyQuery>;
export type PaginatedSeoOrderListQueryResult = Apollo.QueryResult<PaginatedSeoOrderListQuery, PaginatedSeoOrderListQueryVariables>;
export const PaginatedCmsOrderListDocument = gql`
    query PaginatedCmsOrderList($input: paginatedCmsOrderListInput) {
  paginatedCmsOrderList(input: $input) {
    cmsOrderList {
      id
      cmsAdmin {
        email
        firstName
        id
        lastName
        phone
        role
      }
      cmsEmp {
        email
        firstName
        id
        lastName
        phone
        role
      }
      dateOfAssignmentCmsEmployee
      dateOfAssignmentCmsAdmin
      updatedAt
      orderStatus
      seoOrder {
        order {
          id
          client {
            id
            name
          }
          ArticleCounts
          orderStartDate
          orderDueDate
        }
        ClientSiteUrl {
          clientSiteURL
          keyword
          id
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedCmsOrderListQuery__
 *
 * To run a query within a React component, call `usePaginatedCmsOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCmsOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCmsOrderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedCmsOrderListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedCmsOrderListQuery, PaginatedCmsOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedCmsOrderListQuery, PaginatedCmsOrderListQueryVariables>(PaginatedCmsOrderListDocument, options);
      }
export function usePaginatedCmsOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedCmsOrderListQuery, PaginatedCmsOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedCmsOrderListQuery, PaginatedCmsOrderListQueryVariables>(PaginatedCmsOrderListDocument, options);
        }
export type PaginatedCmsOrderListQueryHookResult = ReturnType<typeof usePaginatedCmsOrderListQuery>;
export type PaginatedCmsOrderListLazyQueryHookResult = ReturnType<typeof usePaginatedCmsOrderListLazyQuery>;
export type PaginatedCmsOrderListQueryResult = Apollo.QueryResult<PaginatedCmsOrderListQuery, PaginatedCmsOrderListQueryVariables>;
export const GetPaginatedPotentialSitesForClientDocument = gql`
    query GetPaginatedPotentialSitesForClient($input: getPaginatedPotentialSitesForClientInput) {
  getPaginatedPotentialSitesForClient(input: $input) {
    dms {
      id
      siteUrl
      siteDA
      siteDR
      siteTraffic
      createdAt
      updatedAt
      DomainNiches {
        niche {
          id
          niche
          nicheAbbr
          disabled
          createdAt
          updatedAt
        }
      }
      domainDetails {
        priceAsked
        finalPrice
        specialPrice
        dateOfContact
        status
        updatedAt
        POC
        linkInsertionPrice
        contactedBy {
          id
          firstName
          lastName
          email
          phone
          password
          role
          isActive
          createdAt
          updatedAt
        }
        contactType {
          id
          contactType
          updatedAt
        }
        serviceType {
          id
          serviceType
          updatedAt
        }
      }
      siteContactDetails {
        contactDetails
        contactType {
          id
          contactType
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __useGetPaginatedPotentialSitesForClientQuery__
 *
 * To run a query within a React component, call `useGetPaginatedPotentialSitesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedPotentialSitesForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedPotentialSitesForClientQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedPotentialSitesForClientQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedPotentialSitesForClientQuery, GetPaginatedPotentialSitesForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedPotentialSitesForClientQuery, GetPaginatedPotentialSitesForClientQueryVariables>(GetPaginatedPotentialSitesForClientDocument, options);
      }
export function useGetPaginatedPotentialSitesForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedPotentialSitesForClientQuery, GetPaginatedPotentialSitesForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedPotentialSitesForClientQuery, GetPaginatedPotentialSitesForClientQueryVariables>(GetPaginatedPotentialSitesForClientDocument, options);
        }
export type GetPaginatedPotentialSitesForClientQueryHookResult = ReturnType<typeof useGetPaginatedPotentialSitesForClientQuery>;
export type GetPaginatedPotentialSitesForClientLazyQueryHookResult = ReturnType<typeof useGetPaginatedPotentialSitesForClientLazyQuery>;
export type GetPaginatedPotentialSitesForClientQueryResult = Apollo.QueryResult<GetPaginatedPotentialSitesForClientQuery, GetPaginatedPotentialSitesForClientQueryVariables>;
export const PaginatedCmsAdminOrderListDocument = gql`
    query PaginatedCmsAdminOrderList($input: paginatedCmsAdminOrderListInput) {
  paginatedCmsAdminOrderList(input: $input) {
    orderList {
      id
      clientSiteURL
      requiredDA
      requiredDR
      orderStartDate
      orderDueDate
      ArticleCounts
      orderStatus
      client {
        id
        name
        updatedAt
        clientBaseURL {
          id
          clientID
          baseURL
        }
      }
      seoOrderManager {
        id
        firstName
        lastName
        email
        role
        phone
      }
      SeoOrders {
        id
        dateOfAssignment
        instructionsSeoEmployee
        orderStatus
        updatedAt
        seoEmp {
          id
          firstName
          lastName
          email
          role
          phone
        }
        CmsOrders {
          id
          instructionCmsAdmin
          instructionCmsEmp
          cmsAdmin {
            id
            firstName
            lastName
            email
            role
            phone
          }
          cmsEmp {
            id
            firstName
            lastName
            email
            role
            phone
          }
          dateOfAssignmentCmsEmployee
          dateOfAssignmentCmsAdmin
          updatedAt
          orderStatus
        }
      }
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedCmsAdminOrderListQuery__
 *
 * To run a query within a React component, call `usePaginatedCmsAdminOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCmsAdminOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCmsAdminOrderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedCmsAdminOrderListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedCmsAdminOrderListQuery, PaginatedCmsAdminOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedCmsAdminOrderListQuery, PaginatedCmsAdminOrderListQueryVariables>(PaginatedCmsAdminOrderListDocument, options);
      }
export function usePaginatedCmsAdminOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedCmsAdminOrderListQuery, PaginatedCmsAdminOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedCmsAdminOrderListQuery, PaginatedCmsAdminOrderListQueryVariables>(PaginatedCmsAdminOrderListDocument, options);
        }
export type PaginatedCmsAdminOrderListQueryHookResult = ReturnType<typeof usePaginatedCmsAdminOrderListQuery>;
export type PaginatedCmsAdminOrderListLazyQueryHookResult = ReturnType<typeof usePaginatedCmsAdminOrderListLazyQuery>;
export type PaginatedCmsAdminOrderListQueryResult = Apollo.QueryResult<PaginatedCmsAdminOrderListQuery, PaginatedCmsAdminOrderListQueryVariables>;
export const ViewPackageDocument = gql`
    query ViewPackage($input: searchFilter) {
  viewPackage(input: $input) {
    id
    packageName
    description
    price
    isDisabled
    SubPackage {
      id
      packageDescription
      price
      requiredDA
      subPackageName
    }
  }
}
    `;

/**
 * __useViewPackageQuery__
 *
 * To run a query within a React component, call `useViewPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPackageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViewPackageQuery(baseOptions?: Apollo.QueryHookOptions<ViewPackageQuery, ViewPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewPackageQuery, ViewPackageQueryVariables>(ViewPackageDocument, options);
      }
export function useViewPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewPackageQuery, ViewPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewPackageQuery, ViewPackageQueryVariables>(ViewPackageDocument, options);
        }
export type ViewPackageQueryHookResult = ReturnType<typeof useViewPackageQuery>;
export type ViewPackageLazyQueryHookResult = ReturnType<typeof useViewPackageLazyQuery>;
export type ViewPackageQueryResult = Apollo.QueryResult<ViewPackageQuery, ViewPackageQueryVariables>;
export const ViewSubPackageDocument = gql`
    query ViewSubPackage {
  viewSubPackage {
    id
    subPackageName
    packageDescription
    requiredDA
    price
  }
}
    `;

/**
 * __useViewSubPackageQuery__
 *
 * To run a query within a React component, call `useViewSubPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSubPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSubPackageQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewSubPackageQuery(baseOptions?: Apollo.QueryHookOptions<ViewSubPackageQuery, ViewSubPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSubPackageQuery, ViewSubPackageQueryVariables>(ViewSubPackageDocument, options);
      }
export function useViewSubPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSubPackageQuery, ViewSubPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSubPackageQuery, ViewSubPackageQueryVariables>(ViewSubPackageDocument, options);
        }
export type ViewSubPackageQueryHookResult = ReturnType<typeof useViewSubPackageQuery>;
export type ViewSubPackageLazyQueryHookResult = ReturnType<typeof useViewSubPackageLazyQuery>;
export type ViewSubPackageQueryResult = Apollo.QueryResult<ViewSubPackageQuery, ViewSubPackageQueryVariables>;
export const GetPackageDocument = gql`
    query GetPackage($getPackageId: Int!) {
  getPackage(id: $getPackageId) {
    id
    packageName
    description
    price
    isDisabled
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      getPackageId: // value for 'getPackageId'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<GetPackageQuery, GetPackageQueryVariables>;
export const GetSubPackageDocument = gql`
    query GetSubPackage($getSubPackageId: Int!) {
  getSubPackage(id: $getSubPackageId) {
    id
    subPackageName
    packageDescription
    requiredDA
    price
  }
}
    `;

/**
 * __useGetSubPackageQuery__
 *
 * To run a query within a React component, call `useGetSubPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubPackageQuery({
 *   variables: {
 *      getSubPackageId: // value for 'getSubPackageId'
 *   },
 * });
 */
export function useGetSubPackageQuery(baseOptions: Apollo.QueryHookOptions<GetSubPackageQuery, GetSubPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubPackageQuery, GetSubPackageQueryVariables>(GetSubPackageDocument, options);
      }
export function useGetSubPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubPackageQuery, GetSubPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubPackageQuery, GetSubPackageQueryVariables>(GetSubPackageDocument, options);
        }
export type GetSubPackageQueryHookResult = ReturnType<typeof useGetSubPackageQuery>;
export type GetSubPackageLazyQueryHookResult = ReturnType<typeof useGetSubPackageLazyQuery>;
export type GetSubPackageQueryResult = Apollo.QueryResult<GetSubPackageQuery, GetSubPackageQueryVariables>;
export const PaginatedPackageListDocument = gql`
    query PaginatedPackageList($input: paginatedPackageInput) {
  paginatedPackageList(input: $input) {
    pack {
      id
      description
      packageName
      price
      isDisabled
    }
    totalPages
    totalRows
  }
}
    `;

/**
 * __usePaginatedPackageListQuery__
 *
 * To run a query within a React component, call `usePaginatedPackageListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedPackageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedPackageListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedPackageListQuery(baseOptions?: Apollo.QueryHookOptions<PaginatedPackageListQuery, PaginatedPackageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedPackageListQuery, PaginatedPackageListQueryVariables>(PaginatedPackageListDocument, options);
      }
export function usePaginatedPackageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedPackageListQuery, PaginatedPackageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedPackageListQuery, PaginatedPackageListQueryVariables>(PaginatedPackageListDocument, options);
        }
export type PaginatedPackageListQueryHookResult = ReturnType<typeof usePaginatedPackageListQuery>;
export type PaginatedPackageListLazyQueryHookResult = ReturnType<typeof usePaginatedPackageListLazyQuery>;
export type PaginatedPackageListQueryResult = Apollo.QueryResult<PaginatedPackageListQuery, PaginatedPackageListQueryVariables>;
export const GetAllPackagesDocument = gql`
    query GetAllPackages {
  getAllPackages {
    id
    packageName
    description
    price
    isDisabled
    SubPackage {
      id
      subPackageName
      packageDescription
      requiredDA
      price
    }
  }
}
    `;

/**
 * __useGetAllPackagesQuery__
 *
 * To run a query within a React component, call `useGetAllPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
      }
export function useGetAllPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPackagesQuery, GetAllPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPackagesQuery, GetAllPackagesQueryVariables>(GetAllPackagesDocument, options);
        }
export type GetAllPackagesQueryHookResult = ReturnType<typeof useGetAllPackagesQuery>;
export type GetAllPackagesLazyQueryHookResult = ReturnType<typeof useGetAllPackagesLazyQuery>;
export type GetAllPackagesQueryResult = Apollo.QueryResult<GetAllPackagesQuery, GetAllPackagesQueryVariables>;